/**
 * Avast superclass
 * @author Milan Adam, Ales Gabriel
 * @copyright Avast Software s.r.o &copy;2011-15
 */
if (typeof jQuery !== 'undefined') {
	if (typeof avm === 'object' && typeof avm.define === 'function') {
		avm.define('jquery', jQuery);
	}
}


/**
 * Animation for scrolling on page
 * @version 2.2.4
 * @author Michal Langhoffer <langhoffer@avast.com>, Ales Gabriel <gabriel@avast.com>
 * @module avast.scroll.animateScroll
 * @requires jquery
 * @param {event}  [evt]
 * @param {number} [pos]
 * @param {number} [speed]
 * @param {number} [offset]
 */

avm.define('avast.scroll.animateScroll', function (evt, pos, speed, offset) {
    'use strict';
    var $ = avm.require('jquery'),
        off = offset ? offset : 0,
        position = pos ? pos + off : 0,
        velocity = speed ? speed : 0;

    if(evt && typeof evt.preventDefault === 'function') {
        evt.preventDefault();
    }

    $('html, body').animate(
        {scrollTop: position + 'px'},
        velocity,
		function() {
			if (evt && $(evt.currentTarget).attr('data-hash')) {
				window.location.hash = $(evt.currentTarget).attr('data-hash');
			}
		}
    );
});
/**
 * Append p_bld param to cart links
 * @version 0.2.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.appendPbld
 * @requires jquery
 */
avm.define('avast.web.appendPbld', (function () {
    'use strict';
    
    var $ = avm.require('jquery');
    
    return {
        once: 0,
        init: function(){
            var appendPbld = this;
            var re = '[\\?&](p_bld=[^&#]*)';
            var regex = new RegExp(re, 'i');
            var results = regex.exec(window.location.href);
            var param = '';
            
            if(results){
                // Web
                $('a').each(function() {
                    if (this.href.indexOf('store.avast.com') != -1 && this.href.indexOf('p_bld=') == -1) {
                        param =  (this.href.indexOf('?') > -1) ? '&' + results[1] : '?' + results[1];
                        this.href += param;
                    }
                });
                // Ints
                $('.choice', '.selection').each(function() {
                    var input = $(this).find('input[type=radio]');
                    var cartLink = input.val();
                    if (cartLink.indexOf('store.avast.com') != -1 && cartLink.indexOf('p_bld=') == -1) {
                        param =  (cartLink.indexOf('?') > -1) ? '&' + results[1] : '?' + results[1];
                        input.val(cartLink + param);
                    }
                });
            }

            if (!this.once) {
                $(document).on('avast.ab.updatePrice avast.bab.updatePrice', function() {appendPbld.init();});
                this.once = 1;
            }
        }
    };
})());

/**
 * Avast CampaignMarker set from Google Optimize WYSIWYG editor
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.campaignMarkerChange
 * @copyright Avast Software s.r.o &copy;2020
 */

avm.define('avast.campaignMarkerChange', function() {
	return {
		changeCM: function(abTest, testVariant) {
			avastGlobals.web.abtest = {
				'ticketNumber': abTest,
				'testVariant': testVariant
			}

			document.querySelectorAll('[data-role=cart-link]').forEach(function(el) {
				var dataCM = el.getAttribute('data-campaign-marker').split('~'),
					hrefCM = el.getAttribute('href').split('~');

				dataCM[3] = abTest;
				dataCM[4] = testVariant;
				hrefCM[3] = abTest;
				hrefCM[4] = testVariant;
				el.setAttribute('data-campaign-marker', dataCM.join('~'))
				el.setAttribute('href', hrefCM.join('~'))
			})
		}
	}
});

/**
 * Create SOURCE cookie from ref=cj, ref=td query string parameter
 * @version 0.2.0
 * @author Ales Gabriel, Michal Samaš
 * @module avast.web.cj
 * @todo use avast.storage modules for cookie
 * @copyright Avast Software s.r.o &copy;2015
 */

avm.define('avast.web.cj', (function() {
    var cj = {
        init: function(){
            var cj = this;
            var param = cj.getURLParameter('ref');
            var ref = (typeof param === 'string') ? param.toUpperCase() : null;
            var cjCookieName = 'SOURCE';
            var age = 7776000; // 90 days to expire
            var domain = '.avast.com';
            var path = '/';

			if (ref === 'CJ' || ref === 'TD') {
                cj.setCookie(cjCookieName, ref, domain, path, age);
            }
        },
        getURLParameter: function(name) {
            return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]);
        },
        setCookie: function(name,value,domain,path,age) {
            var exp = "",p = ";path=/",d = "";
            var val = (value) ? encodeURIComponent(value) : '';
            if (age) {
                d = new Date();
                d.setTime(d.getTime()+(age*1000));
                exp = ";expires="+d.toUTCString()+";max-age="+ age;
            }
            if(path){
                p = ";path="+path;
            }    
            if(domain){
                d = ";domain="+domain;
            }  

            document.cookie = name+"="+val+exp+d+p+";";
        }
    };

return cj;

})());

/**
 * Event emitter
 * @version 1.0.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.event.emitter
 * @return {Function}  Emitter constructor
 */
avm.define('avast.event.emitter', (function(){
	'use strict';

	/**
	 * Event emitter
	 * @version 1.2.1
	 * @see {@link https://github.com/component/emitter}
	 */

	/*
	(The MIT License)

	Copyright (c) 2014 Component contributors <dev@component.io>

	Permission is hereby granted, free of charge, to any person
	obtaining a copy of this software and associated documentation
	files (the "Software"), to deal in the Software without
	restriction, including without limitation the rights to use,
	copy, modify, merge, publish, distribute, sublicense, and/or sell
	copies of the Software, and to permit persons to whom the
	Software is furnished to do so, subject to the following
	conditions:

	The above copyright notice and this permission notice shall be
	included in all copies or substantial portions of the Software.

	THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
	OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
	NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
	HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
	WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
	FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
	OTHER DEALINGS IN THE SOFTWARE.
	*/

	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */

	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};

	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */

	function mixin(obj) {
	  for (var key in Emitter.prototype) {
		obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}

	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
		.push(fn);
	  return this;
	};

	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.once = function(event, fn){
	  function on() {
		this.off(event, on);
		fn.apply(this, arguments);
	  }

	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};

	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */

	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};

	  // all
	  if (0 == arguments.length) {
		this._callbacks = {};
		return this;
	  }

	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;

	  // remove all handlers
	  if (1 == arguments.length) {
		delete this._callbacks['$' + event];
		return this;
	  }

	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
		cb = callbacks[i];
		if (cb === fn || cb.fn === fn) {
		  callbacks.splice(i, 1);
		  break;
		}
	  }
	  return this;
	};

	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */

	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
		, callbacks = this._callbacks['$' + event];

	  if (callbacks) {
		callbacks = callbacks.slice(0);
		for (var i = 0, len = callbacks.length; i < len; ++i) {
		  callbacks[i].apply(this, args);
		}
	  }

	  return this;
	};

	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */

	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};

	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */

	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};

	return Emitter;
})());

/**
 * Footer - global footer events
 * Opens language selector on navigation
 * @version 1.0.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.footer
 */

avm.define('avast.web.footer', function() {
	'use strict';

	var $languageSelectorBtn = $('.select-region-button'),
		languageSelectorBodyCssClass = 'first-menu-regions',
		jqObject;

	jqObject = $languageSelectorBtn.on('click', function(evt) {
		evt.preventDefault();
		document.body.classList.add(languageSelectorBodyCssClass);
	});

	return jqObject;
});

/**
 * Avast Number format
 * @version 2.1.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.number.format
 * @requires jquery
 */

avm.define('avast.number.format', (function () {
    'use strict';
    var $ = avm.require('jquery');
    return {
        options: {
            decimal: 0
        },
        translate: function (number, decimal) {
            var root = this,
                avastGlobals = window.avastGlobals;

            if (decimal !== undefined) {
                this.options.decimal = decimal;
            } else {
                this.options.decimal = 0;
            }
            if (!isNaN(number) && avastGlobals && typeof avastGlobals.web === 'object') {
                var ds = avastGlobals.web.numberDecimalSeparator,
                    ts = avastGlobals.web.numberThousandSeparator;
                if (ds && ds) {
                    var val = $().number_format(
                        number,
                        {
                            numberOfDecimals: root.options.decimal,
                            decimalSeparator: ds,
                            thousandSeparator: ts,
                            symbol: ""
                        }
                    );
                    return val;
                } else {
                    return number;
                }
            } else {
                return number;
            }
        }
    };
})());
/**
 * Avast hadd manipulation class
 * @version 2.1
 * @author Michal Langhoffer, Milan Adam, Ales Gabriel
 * @copyright Avast Software s.r.o &copy;2014
 */
avm.define('avast.hadd', function () {
    'use strict';
    return {
        haddValue: '',
        options: {
            haddRegex: "[\\?&]hadd=([^&#]*)",
            providers: {
                "dr-store.avast.com": {
                    idRegex: "[\\?&]PRODUCT([^&#=]*)",
                    paramTmpl: "HADD{{id}}[ADDITIONAL1]={{hadd}}"
                },
                "dr-store.avast.co.jp": {
                    idRegex: "productID[\\.]([^&#=\/]*)[\/]",
                    paramTmpl: "/HADD.{{id}}/ADDITIONAL1.{{hadd}}"
                },
                "store.avast.com": {
                    idRegex: "productID[\\.]([^&#=\/]*)[\/]",
                    paramTmpl: "/HADD.{{id}}/ADDITIONAL1.{{hadd}}"
                },
                "store.avast.ru": {
                    paramTmpl: "licenseid={{hadd}}"
                },
                "store.avast.ua": {
                    paramTmpl: "licenseid={{hadd}}"
                }
            }
        },

        init: function (params) {
            //console.time('hadd sken');
            var root = this,
                listen = false;

            if (params !== undefined) {
                for (var key in params){
                    this.options[key] = params[key];
                }
            }

            var regex = new RegExp(this.options.haddRegex,"i"),
                results = regex.exec(window.location.href);

            if (results === null) {
                // Stops here if no HADD in url
                return 1;
            } else {
                if (!this.haddValue){
                    // Store hadd parameter value
                    this.haddValue = results[1];
                    // Listen to price update and sken again.
                    // TODO: Remove 'avast.ab.updatePrice', 'avast.bab.updatePrice' events, when all triggers replaced with 'priceUpdate.ab.avast'.
                    $(document).on('priceUpdate.ab.avast avast.ab.updatePrice avast.bab.updatePrice', function () {root.init();});
                }

                // Scan all links, radio buttons
                $('a, input[type="radio"]').each(function () {
                    var $this = $(this),
                        cartUrl = $this.attr('href') || $this.attr('value') || "",
                        attrName = 'href',
                        param = root.getHaddParam(cartUrl),
                        delim = '';

                    if (param && cartUrl.indexOf(param) === -1) {
                        if (param.charAt(0) !== '/' && cartUrl.substr(cartUrl.length - 1) !== '&') {
                            delim = (cartUrl.indexOf("?") == -1) ? "?" : "&";
                        }
                        cartUrl = cartUrl + delim + param;

                        // check if it has specified property
                        $.each(this.attributes, function () {
                            if (this.specified && this.name) {
                                if (this.name.toLowerCase() === 'href') {
                                    attrName = 'href';
                                    return false;
                                } else if (this.name.toLowerCase() === 'value') {
                                    attrName = 'value';
                                }
                            }
                        });

                        $this.attr(attrName, cartUrl);
                    }
                });
            }
            //console.timeEnd('hadd sken');
        },

        getHaddParam: function (url) {
            var providers = this.options.providers,
                hadd = this.haddValue,
                param,
                regID,
                id;

            for (var key in providers) {
                if (url && url.indexOf(key) != -1) {
                    // Look for ID number, if provider has regexp for id search
                    if (providers[key].idRegex) {
                        regID = providers[key].idRegex ? new RegExp(providers[key].idRegex,"i") : '';
                        id = regID.exec(url);
                    }
                    // Replace param template with id
                    if (id &&providers[key].paramTmpl) {
                        param = providers[key].paramTmpl.replace('{{id}}', id[1]).replace('{{hadd}}', hadd);
                    }
                    // Replace param template without id
                    if (!id && providers[key].paramTmpl) {
                        param = providers[key].paramTmpl.replace('{{hadd}}', hadd);
                    }
                }
            }
            return param;
        },

        getHadd: function (el) {
            // Check in which elements attribute cart link is stored.
            var url;

            if (el && el.nodeType === 1) {
                if (el.href) {
                    url = el.href;
                }
                if (el.value) {
                    url = el.value;
                }
            }

            return this.getHaddParam(url);
        }
    };
});
/**
 * Check if cookie support is enabled
 * @version 1.0.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.isCookieEnabled
 */
avm.define('avast.storage.isCookieEnabled', (function() {
	'use strict';
	if (navigator.cookieEnabled) {
		return true;
	} else {
		var key = 'isCookieEnabled';
		document.cookie = key + '=1';
		if (document.cookie.indexOf(key + '=1') !== -1) {
			document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT';
			return true;
		} else {
			return false;
		}
	}
})());

/**
 * Check if storage support is enabled
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.isStorageEnabled
 */
avm.define('avast.storage.isStorageEnabled', (function() {
	'use strict';
	try {
		if (typeof sessionStorage === 'object' && sessionStorage && typeof localStorage === 'object' && localStorage) {
			var key = 'isStorageEnabled';
			sessionStorage.setItem(key, '1');
			sessionStorage.removeItem(key);
			localStorage.setItem(key, '1');
			localStorage.removeItem(key);
			return true;
		}
	} catch (error) {
		if (typeof console === 'object' && console && typeof console.warn === 'function') {
			console.warn(error);
		}
	}
	return false;
})());

/**
* Avast Language selector     
* @version 2.0.3
* @author Michal Langhoffer, Ales Gabriel
* @module avast.web.languageSelector
* @requires jquery
* @requires avast.scroll.animateScroll
*/

avm.define('avast.web.languageSelector', function () {
	'use strict';
	var $ = avm.require('jquery'),
		animateScroll = avm.require('avast.scroll.animateScroll'),
		$langSelector = $('#lang-selector'),
		$html = $('html');
	return {
		init: function () {
			var self = this;
			// Highligh current region
			$langSelector.find('.' + avast.locale).addClass('highlight');

			$('.region-selector a, #lang-selector .selector-close').on('click', $.proxy(self.toggleHandler, self));

			$(document).on('keydown.languageSelector.avast', $.proxy(self.keyPressHandler, self));
			$langSelector.on('click', $.proxy(self.clickHandler, self));
		},
		toggleHandler: function (evt) {
			// Can be called without argument so check it first

			if (evt) {
				evt.preventDefault();
				evt.stopPropagation();
			}
			if ($(evt.currentTarget).is('.region .region-selector-button') || evt.target.className === 'selector-close' || evt.which === 27) {
				$langSelector.toggleClass('open');
			}
			if ($langSelector.hasClass('open')) {
				$html.addClass('lang-selector-open');
				if (animateScroll) {
					var pos = $(window).scrollTop();
					animateScroll(evt, pos);
				}
			} else {
				$html.removeClass('lang-selector-open');
			}
		},
		keyPressHandler: function (evt) {
			if (evt.which === 27 && $('.lang-selector-open').length > 0) {
				this.toggleHandler(evt);
			}
		},
		clickHandler: function (evt) {
			var target = $(evt.target);
			if (target.prop('tagName').toLowerCase !== 'a' && target.parents('.rs-region').length === 0) {
				evt.preventDefault();
				this.toggleHandler(evt);
			} else {
				evt.stopPropagation();
			}
		}
	};
});
/**
 * mqMarker module - Mark elements with css class based on media query
 * Indicate what type of resolution (desktop/mobile) is presented.
 * Based on that, specific elements are marked with css class.
 * Can be used for event delegation and different behavior on desktop/mobile
 * Only one marker per element is possible
 * @param mqMarker {string} Marker as css class. Must have unique prefix separated with "-".
 * @version 0.0.1
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.mqMarker
 * @param selectors {String} Comma separated list of selectors 
 * @param context {DOMElement} Context for querySelector 
 * @returns els {Array} DOM elements
 */
	
avm.define('avast.web.mqMarker', function(mqMarker, selectors) {
	// Define selectors for elements which will be marked.
	var sels = selectors || 'body',
		prefixRe = /^.*?-/,
		mqMarkerPrefix = mqMarker.match(prefixRe),
		els = [],
		nList = document.querySelectorAll(sels),
		list = Array.prototype.slice.call(nList); // Support IE11

	if (typeof mqMarker !== 'string' && mqMarkerPrefix.length === 0) {
		console.log('mqMarker prefix separated by "-" is missing: %s', mqMarker);
		return els;
	}

	list.forEach(function(el) {
		var cssClasses = el.classList;

		window.console.log(cssClasses.length);
		// Removes all classes with the same prefix
		if (cssClasses.length) {
			for (var i = 0; cssClasses.length > i; i++) {
				if (cssClasses[i].match(prefixRe)[0] === mqMarkerPrefix[0]) {
					// console.log('Removed class: %s', cssClasses[i]);
					el.classList.remove(cssClasses[i]);
				}
			}
		}

		if (mqMarker) {
			el.classList.add(mqMarker);
		}

		els.push(el);
	});

	return els;
});

/**
 * Avast Overlay Popup
 * @version 1.0.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.overlayPopup
 * @requires jquery
 */
avm.define('avast.web.overlayPopup', function () {
    'use strict';
    var $ = avm.require('jquery'),
        $body = $('body'),
        $overlayBox = $('.overlay-box'),
        $overlayBoxTrigger = $('.overlay-box-trigger'),
        $overlayBoxContainerClose = $('.overlay-box-container .close');
        // Disabling scroll event when overlay active
    function overlayScrollDisable() {
        $body.on({
            'mousewheel': function (event) {
                if (event.target.id === 'el') {
                    return;
                }
                event.preventDefault();
                event.stopPropagation();
            }
        });
        if (document.all && document.querySelector && !document.addEventListener) {
            $body.css('overflow', 'auto');
        } else {
            $body.css('overflow', 'hidden');
        }
    }
    // Window resize functions
    $(window).on('resize', function () {
        if ($('[class*="overlay-box"]').hasClass('is-visible')) {
            overlayScrollDisable();
        }
    });
    // scroll event disable when popup active
    $('[class*="overlay-box-trigger"]').on('click', function () {
        overlayScrollDisable();
    });
    $overlayBoxContainerClose.on('click', function () {
        $body.off('mousewheel');
        $body.css('overflow', 'auto');
    });

    //open popup
    $overlayBoxTrigger.on('click', function (event) {
        event.preventDefault();
        var _data = ($(this).attr('data-box'));
        $('.overlay-box[data-box*="' + _data + '"]').addClass('is-visible');
    });

    //close popup
    $overlayBox.on('click', function (event) {
        if ($(event.target).is('.close') || $(event.target).is('.overlay-box')) {
            event.preventDefault();
            $(this).removeClass('is-visible');
        }
    });
    //close popup when clicking the esc keyboard button
    $(document).on('keyup', function (event) {
        if (event.which === 27) {
            $overlayBox.removeClass('is-visible');
            $body.off('mousewheel');
            $body.css('overflow', 'auto');
        }
    });
});
/**
 * Avast Router
 * @version 1.0.1
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.router
 * @requires jquery
 */
avm.define('avast.web.router', (function () {
	'use strict';
	var $ = avm.require('jquery'),
		routes,
		self,
		w = window,
		$window = $(window);

	return {
		/*
		 * add window hashchange listener
		 * look for key in routes object and execute its function
		 */
		hashChangeListener: function () {
			self = this;
			$window.on('hashchange', function () {
				self.exec(w.location.hash.substring(1));
			});
		},
		/*
		 * @param {string} [path]
		 * change hash in URL if it is not the same as current one, otherwise execute function from routes object
		 */
		navigate: function (path) {
			if (w.location.hash.substring(1) !== path) {
				w.location.hash = path;
			} else {
				this.exec(path);
			}
		},
		/* 
		 * @param {string} [path]
		 * execute function from routes object
		 */
		exec: function (path) {
			if (routes[path]) {
				routes[path]();
			} else {
				return;
			}
		},
		/*
		 * @param {object} [path]
		 * set the routes object
		 * add hashchange listener
		 * after page load check hash and execute function from routes object
		 * return routes object if path is object, otherwise throw error
		 */
		set: function (path) {
			routes = path;
			self = this;
			self.hashChangeListener();
			self.navigate(w.location.hash.substring(1));
			if (typeof path === 'object') {
				return routes;
			} else {
				throw new Error('Object has to be passed to router.set()');
			}
		}
	};
})());
/**
 * Serialize URL parameters from object to string
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.url.serialize
 * @param {Object} urlObject
 * @returns {string}
 */
avm.define('avast.url.serialize', function(urlObject) {
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	if (typeof urlObject === 'object' && urlObject) {
		var urlString = '';
		for (var key in urlObject) {
			if (hasOwnProperty.call(urlObject, key)) {
				if (urlString.length) {
					urlString += '&';
				}
				urlString += encodeURIComponent(key) + '=' + encodeURIComponent(urlObject[key]);
			}
		}
		return urlString;
	} else {
		throw new Error('Invalid method arguments to avast.url.serialize');
	}
});

/**
 * Set cookie avastComLocale with locale value
 * @version 0.1.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.setLanguage
 */
avm.define('avast.web.setLanguage', function (lang) {
    'use strict';    
   
    var d=new Date();
    d.setDate(d.getDate() + 365);
    document.cookie = "avastComLocale="+lang+";path=/;EXPIRES=" + d.toGMTString();    
});

/**
 * BXslider wrapper
 * @version 0.1.0
 * @author Milan Adam <adam@avast.com>, Ales Gabriel <gabriel@avast.com>
 * @module avast.web.slider
 * @requires jquery
 */

avm.define('avast.web.slider', (function(){

    var $ = avm.require('jquery');

    var slider = {
    /**
     * @var bxSlider slider - instance of slider
     */
    slider:null,
    /**
     * Slider default options
     * @var boolean pager - creating pager or not
     * @var boolean controls - creating controls(prev/next) or not
     * @var boolean auto - start scrolling or not
     * @var int pause - pause between scrolling
     */
    options:{
        pager: true,
        controls:false,
        auto:true,
        pause:20000,
        prevDomEl:".prev",
        nextDomEl:".next",
        subheaderDomEl:"#subheader ul.home li",
        textPagerDomEl:".slide-text",
        useCSS: false
    },
    /**
     * Initialization
     * @param string type - choosing predefined slider
     * @param string cDomEl - slider contnet wrapper
     * @param object params - parameters rewriting default options
     */
    init:function(type,cDomEl,params){
        var root = this;
        var settings = this.options;
        var context = $(cDomEl).closest('.AVsizer').parent();

        if(params !== undefined){
            for(var param in params){
                settings[param] = params[param];
            }
        }

        if(type === null) type = "";
        switch(type){
            case "v9":
                var slideLocked = false;
                var pagerEls = context.find(root.options.textPagerDomEl).children();
                settings.mode = 'fade';
                settings.speed = 500;
                settings.onSlideBefore = function($slideElement, oldIndex, newIndex){
                    pagerEls.removeClass('active');
                    pagerEls.eq(newIndex).addClass('active');
                    slideLocked = true;
                };
                settings.onSlideAfter = function($slideElement, oldIndex, newIndex){
                    slideLocked = false;
                };


                // Create slider
                this.slider = $(cDomEl).bxSlider(settings);
                context.find(settings.prevDomEl).click(function(e){
                    root.slider.goToPrevSlide();
                    root.slider.stopAuto();
                    return false;
                });
                context.find(settings.nextDomEl).click(function(e){
                    root.slider.goToNextSlide();
                    root.slider.stopAuto();
                    return false;
                });
                $('.slide-text').children(':not(hr)').on('click', function(){
                    var i = pagerEls.index(this);
                    if (!slideLocked){
                      pagerEls.removeClass('active');
                      pagerEls.eq(i).addClass('active');
                      root.slider.stopAuto();
                      root.slider.goToSlide(i);
                    }
                });
                break;

            case "v9hp":
                // Create slider
                settings.mode = 'fade';
                settings.speed = 900;
                settings.onSlideBefore = function($slideElement, oldIndex, newIndex){
                    var klasPrefix = "bg-slide-",
                        klas = klasPrefix + (newIndex + 1);


                    $('#top').removeClass(function(i, c) {
                        var klas = c.match(/bg-slide-\d+/g);
                        return klas ? klas.join(' ') : false;
                    });
                    $('#top').addClass(klas);
                };
                this.slider = $(cDomEl).bxSlider(settings);
                context.find(settings.prevDomEl).click(function(e){
                    root.slider.goToPrevSlide();
                    return false;
                });
                context.find(settings.nextDomEl).click(function(e){
                    root.slider.goToNextSlide();
                    return false;
                });
                break;

            case "hp":
                settings.onBeforeSlide = function(currentSlide, totalSlides){
                    $(root.options.subheaderDomEl).removeClass('active');
                    var i = currentSlide + 1;
                    $(root.options.subheaderDomEl+':nth-child('+i+')').addClass('active');
                };
                this.slider = $(cDomEl).bxSlider(settings);
                $(settings.prevDomEl).click(function(){
                    root.slider.goToPrevSlide();
                    $(root.options.subheaderDomEl).removeClass('active');
                    var i = root.slider.getCurrentSlide() + 1;
                    $(root.options.subheaderDomEl+':nth-child('+i+')').addClass('active');
                    return false;
                });

                $(settings.nextDomEl).click(function(){
                    root.slider.goToNextSlide();
                    $(root.options.subheaderDomEl).removeClass('active');
                    var i = root.slider.getCurrentSlide() + 1;
                    $(root.options.subheaderDomEl+':nth-child('+i+')').addClass('active');
                    return false;
                });

                $(settings.subheaderDomEl).on('click',function(){
                    var thumbIndex = $(root.options.subheaderDomEl).index(this);
                    root.slider.goToSlide(thumbIndex);

                    return false;
                });

                $(settings.subheaderDomEl+':first').addClass('active');
                break;

            case "awards":
                if($(cDomEl + " .frame").length > settings.maxSlides){
                    var awardsSlider = $(cDomEl).bxSlider(params);
                } else {
                    $(params.nextSelector).hide();
                    $(params.prevSelector).hide();
                }
                break;

            default:
                break;
        }

        return this.slider;
    },
    getSlider:function(){
        return this.slider;
    },
    forceSlider : function (slider){
        return function(){
            if(slider) {
                var currentSlide = slider.getCurrentSlide();
                slider.reloadSlider();
            }
        };
    }
    };

    return slider;

})());

/**
 * Hash anchor smooth scroll
 * @version 2.4.2
 * @author Michal Langhoffer <langhoffer@avast.com>, Aleš Gabriel <gabriel@avast.com>
 * @module avast.scroll.smoothScroll
 * @requires jquery
 * @requires avast.scroll.animateScroll
 */


avm.define('avast.scroll.smoothScroll', function () {
    'use strict';
    var $ = avm.require('jquery'),
        animateScroll = avm.require('avast.scroll.animateScroll');
    $('a[href*="#"]:not([href="#"])').click(function (evt) {
        var $this = $(this);
        var offset = $(this).closest('#tabs-anchor').length ? (2 - $(this).closest('#tabs-anchor').height()) : 0;

        if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '')
            && location.hostname === this.hostname
            && !$this.hasClass('no-smooth-scroll')
            && $this.closest('.tabs-nav-faq').length === 0
            && $this.closest('#support-faq #tabs').length === 0) {
            var target = $(this.hash);
            target = target.length ? target : $('[name="' + this.hash.slice(1) + '"]');

            if (target.length && typeof animateScroll === 'function') {
                animateScroll(evt, target.offset().top, 400, offset);
            }
        }
    });
});

/**
 * Factory for storage object
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.storageFactory
 * @returns {Object}
 */
avm.define('avast.storage.storageFactory', function() {
	'use strict';
	var hasOwnProperty = Object.prototype.hasOwnProperty,
		data = {};
	return {
		length: 0,

		/**
		 * Add key/value pair
		 * @param {*} key
		 * @param {*} value
		 */
		setItem: function(key, value) {
			if (typeof key !== 'undefined' && typeof value !== 'undefined') {
				key = encodeURIComponent(key);
				value = encodeURIComponent(value);
				if (!hasOwnProperty.call(data, key)) {
					this.length++;
				}
				data[key] = value;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.setItem');
			}
		},

		/**
		 * Get value associated with key
		 * @param {*} key
		 * @returns {string}
		 */
		getItem: function(key) {
			if (typeof key !== 'undefined') {
				key = encodeURIComponent(key);
				return typeof data[key] !== 'undefined' ? decodeURIComponent(data[key]) : null;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.getItem');
			}
		},

		/**
		 * Remove key/value pair
		 * @param {*} key
		 */
		removeItem: function(key) {
			if (typeof key !== 'undefined') {
				key = encodeURIComponent(key);
				if (hasOwnProperty.call(data, key)) {
					delete data[key];
					this.length--;
				}
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.removeItem');
			}
		},

		/**
		 * Get name of nth key
		 * @param {number} n
		 * @returns {string}
		 */
		key: function(n) {
			if (typeof n === 'number') {
				var i = 0;
				for (var key in data) {
					if (hasOwnProperty.call(data, key)) {
						if (i === n) {
							return decodeURIComponent(key);
						} else {
							i++;
						}
					}
				}
				return null;
			} else {
				throw new Error('Invalid method arguments to avast.storage.storageFactory.key');
			}
		},

		/**
		 * Clear all items
		 */
		clear: function() {
			data = {};
			this.length = 0;
		}

	};
});

/**
 * Avast tabs class
 * @version 0.1.0 
 * @author Milan Adam <adam@avast.com>, Ales Gabriel <gabriel@avast.com>
 * @module avast.web.tabs
 * @requires module:jquery
 * @copyright Avast Software s.r.o &copy;2013
 */

avm.define('avast.web.tabs', (function() {
    
    var $ = avm.require('jquery');

    var tabs = {
        /**
         * @var string nId - DOM element that has connected tabs
         */
        nId:null,
        /**
         * Tabs default options
         * @var boolean animate - animate on change or not
         * @var string tabs - css selector of relative position of main list in tabs container
         */
        options:{
            animate: true,
            tabs: "> div#tabs-navigation > ul > li"
        },
        /**
         * Initialization
         * @param string eId - DOM element where tabs are included
         * @param object params - parameters rewriting default options
         */
        init:function(eId,params){
            this.nId = eId;
            if(params !== undefined){
                for(var param in params){
                    this.options[param] = params[param];
                }
            }

            $(this.nId).easytabs(this.options);
        },
        /**
         * Method for selecting specific tab
         * @param string sHref - id of the desired tab with perfix '#' e.g. '#tab3'
         */
        select:function(sHref){
            $(this.nId).easytabs('select',sHref);
        }
    };

    return tabs;

})());

/**
* Push data to GTM dataLayer. 
* @version 1.0.0
* @author Ales Gabriel <gabriel@avast.com>
* @module avast.web.tracker
* @desc GTM dataLayer helper. Primary centralize various window.datalayer pushes.
* @requires jquery
*/
avm.define('avast.web.tracker', (function () {
	'use strict';

	var $ = avm.require('jquery');
	
	window.dataLayer = window.dataLayer || []; 

	/*
	 *	Config events and handlers.
	 *	If tracked via GTM, only datalayer.push should be required.
	 */

	// Define callbacks for events
	var trackEvents = {
		'chromeOffer': {
			/**
			 * Track banner impression
			 * @return {Integer} Length of datalayer
			 */
			view: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer', 
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'View'
				});
			},
			/**
			 * Track clicking on download Chrome button
			 * @param  {Object} evt Event object
			 * @return {Integer}  Length of dataLayer
			 */
			click: function(evt){
				//console.log(evt);
				return window.dataLayer.push({
					'event' : 'chromeOffer', 
					'eventCategory' : 'Chrome',
					'eventAction' : 'Chrome Offer',
					'eventLabel' : 'Click'
				});
			}
		},
		/**
		 * Password checker on first char - only once per visit 
		 * @param  {Object} evt Event object
		 * @return {Int}     Length of dataLayer array
		 */
		'passwordCheck' : (function(){
			var called = 0;

			return function(evt){
				if(!called){
					called = 1;
					//console.log('passwordCheck event: %o', evt);
					return window.dataLayer.push({
						'event' : 'passwordCheck', // First char filled
					});
				}
			};
		})()
	};

	// Bind events
	$(document).on('passwordCheck.avast', function(){
		methods.track('passwordCheck');
	});

	///////////////////////////////////////////////////////////////////////////////////
	
	/*
	 * Methods
	 */	
	var methods = {
		/**
		 * Track event 
		 * @param  {String}   evtName  Event name. Looking for callback. Dot notation allowed.  
		 * @param  {Object}   [evtObj]  Event object
		 * @param  {Function} [callback] Callback handler. If not defined in param, lookup on module internal callbacks storage is made. 
		 */
		track: function(evtName, evtObj, callback){
			var handler = callback || trackEvents,
				spaces = (typeof evtName === 'string') ? evtName.split('.') : null,
				args = evtObj ? [evtObj] : [], // IE 8 with no arguments 
				space,
				toString = Object.prototype.toString;
			
			// TODO: Do not step into object cycles if callback is only plain function by default
			if ((toString.call(handler) === '[object Function]' || toString.call(handler) === '[object Object]') && spaces && spaces.length > 0){
				for (var i = 0; i < spaces.length; i++) {
					space = spaces[i];
					if (handler !== null && space in handler) {
						handler = handler[space];
					
						// Function founded earlier than in last cycle considered as incorrect.
						// So properties defined on functions are not allowed.
						if (toString.call(handler) === '[object Function]' && i !== (spaces.length - 1)) {						
							handler = null;
						}
					}
				}
			}

			if (typeof handler === 'function') {
				return handler.apply(this, args); // FIXME: Change to call.
			}
		}
	};


	// Export methods
	return methods;
})());

/**
 * Unserialize URL parameters from string to object
 * @version 1.2.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.url.unserialize
 * @param {string} [urlString]
 * @returns {Object}
 */
avm.define('avast.url.unserialize', function(urlString) {
	'use strict';
	urlString = typeof urlString === 'undefined' ? location.search : urlString;
	if (typeof urlString === 'string') {
		var urlObject = {},
			urlQuery = urlString.replace(/#.*|.*\?/g, '');
		if (urlQuery.length) {
			var urlParameters = urlQuery.split('&'),
				urlParametersLength = urlParameters.length,
				urlParameter = [];
			for (var i = 0; i < urlParametersLength; i++) {
				urlParameter = urlParameters[i].split('=');
				urlObject[decodeURIComponent(urlParameter[0])] = decodeURIComponent(urlParameter[1] || '');
			}
		}
		return urlObject;
	} else {
		throw new Error('Invalid method arguments to avast.url.unserialize');
	}
});

/**
 * Avast UrlBag (adds encoded params to cart links)
 * @version 0.1.0
 * @author Vojtech Sir <sir@avast.com>
 * @module avast.web.urlBag
 * @copyright Avast Software s.r.o &copy;2014
 */
avm.define('avast.web.urlBag', (function() {
    var urlBag = {    
        data: {},
        addValue: function(key, value) {
            this.data[key] = String(value);
        },
        getData: function() {
            return this.data;
        },
        getEncodedData: function() {
            var base64 = this.base64encode(this.stringify(this.data));
            return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
        },   
        stringify: function(obj) {
            if (typeof JSON != 'undefined' && JSON && JSON.stringify) {
                return JSON.stringify(obj);
            }

          var t = typeof(obj);
          if (t != 'object' || obj === null) {
            if (t == 'string') {
                    obj = '"' + obj + '"';
                }
            return String(obj);
          }
          else {
            var n, v, json = [], arr = (obj && obj.constructor == Array);

            for (n in obj) {
              v = obj[n]; t = typeof(v);
              if (t == 'string') v = '"' + v + '"';
              else if (t == 'object' && v !== null) v = this.stringify(v);
              json.push((arr ? "" : '"' + n + '":') + String(v));
            }
            return (arr ? '[' : '{') + String(json) + (arr ? ']' : '}');
          }
        },
        // http://phpjs.org/functions/base64_encode/
        base64encode: function(data) {
            if (!data) {
                return data;
            }

            var b64 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
            var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, ac = 0, enc = '', tmp_arr = [];

            do { // pack three octets into four hexets
                o1 = data.charCodeAt(i++);
                o2 = data.charCodeAt(i++);
                o3 = data.charCodeAt(i++);

                bits = o1 << 16 | o2 << 8 | o3;

                h1 = bits >> 18 & 0x3f;
                h2 = bits >> 12 & 0x3f;
                h3 = bits >> 6 & 0x3f;
                h4 = bits & 0x3f;

                // use hexets to index into b64, and append result to encoded string
                tmp_arr[ac++] = b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
            } while (i < data.length);

            enc = tmp_arr.join('');
            var r = data.length % 3;
            return (r ? enc.slice(0, r - 3) : enc) + '==='.slice(r || 3);
        }
    };

    return urlBag;

 })());

/**
 * Waypoints
 * @version 1.1.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.waypoints
 * @requires jquery
 * @param {DOM element} $element
 * @param {Number} offsetTop
 * @param {Number} offsetBottom
 * @param {Boolean} waypoint
 * @returns {boolean}
 */
avm.define('avast.web.waypoints', function($element, offsetTop, offsetBottom, waypoint) {
	'use strict';
	var $ = avm.require('jquery'),
		elementTop = $element.offset().top,
		elementBottom = elementTop + $element.outerHeight(),
		viewportTop = $(window).scrollTop(),
		viewportBottom = viewportTop + window.innerHeight,
		offsetTop = offsetTop ? offsetTop : 0,
		offsetBottom = offsetBottom ? offsetBottom : 0;

	if (waypoint) {
		if (viewportTop >= elementTop) {
			return true;
		} else {
			return false;
		}
	} else {
		if (offsetTop < 1 && offsetTop !== 0) {
			offsetTop = $element.outerHeight() * offsetTop;
		}

		if (offsetBottom < 1 && offsetBottom !== 0) {
			offsetBottom = $element.outerHeight() * offsetBottom;
		}

		return elementBottom - offsetBottom > viewportTop && elementTop + offsetTop < viewportBottom;
	}
});

/**
 * Avast Aswparam (adds /ASWPARAM to cart links)
 * @version 0.5.0
 * @author Vojtech Sir <sir@avast.com>, Ales Gabriel <gabriel@avast.com>, Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.aswparam
 * @requires module:avast.web.urlBag
 * @requires module:jquery
 * @copyright Avast Software s.r.o &copy;2015
 */

avm.define('avast.web.aswparam', (function() {

    var $ = avm.require('jquery'),
        urlBag = avm.require('avast.web.urlBag');

    var aswparam = {
        inited: false,
        cartLinks: {
            'CX': {
                urls: ['store.avast.com'],
                paramPattern: '/ASWPARAM.%urlBagValue%',
                paramRegex: /(\/ASWPARAM\.)[^/]+/,
                appendBeforeRegex: /(\/ThemeID\.)/
            },
            'SL': {
                urls: ['store.avast.ru', 'store-kz.avast.com', 'store.avast.ua', 'store-sl.avast.com'],
                paramPattern: 'ASWPARAM=%urlBagValue%&',
                paramRegex: /(&(amp;)?ASWPARAM=)[^&]+/,
                appendBeforeRegex: /(quantity=)/
            }
        },
        globalCartLinks: ['store.avast.com', 'store.avast.ru', 'store-kz.avast.com', 'store.avast.ua', 'store-sl.avast.com'],
        init: function(){
            var cookies = {'p_pro': 'x-avast-pro', 'p_vbd': 'x-avast-vbd', 'p_hid': 'x-avast-hid'},
                testCookieFail = ['p_pro', 'p_vbd'],
                urlParams = {'p_glic': 'p_glic'},
                values = {},
                cookieFail = false,
                aswparam = this,
                paramsFromUrl = avm.require('avast.url.unserialize')(window.location.href);

            /* OO-8998 */
            if (window.location.pathname.indexOf('cleanup') > -1) {
                   if (typeof paramsFromUrl.ppc !== 'undefined' && paramsFromUrl.ppc.length > 0) {
                    values.ppc = paramsFromUrl.ppc;
                   }
            }
            /* /OO-8998 */

            /* WCS-2448 */
            $(document).on('priceUpdate.ab.avast avast.ab.updatePrice avast.bab.updatePrice', function() {
                aswparam.updateAswparamPlaceholderLinks(aswparam.globalCartLinks, paramsFromUrl.aswparam);
             });

            if (paramsFromUrl.aswparam && paramsFromUrl.aswparam.length > 0) {
                aswparam.updateAswparamPlaceholderLinks(aswparam.globalCartLinks, paramsFromUrl.aswparam);
            } else {
                aswparam.updateAswparamPlaceholderLinks(aswparam.globalCartLinks);
            /* /WCS-2448 */

                $.each(cookies, function(paramName, cookieName) {
                    values[paramName] = aswparam.getClientInfo(paramName, cookieName);
                    if ($.inArray(paramName, testCookieFail) > -1 && !values[paramName]) {
                        cookieFail = true;
                    }
                });

                if (!cookieFail) {
                    $.each(values, function(name, value) {
                        urlBag.addValue(name, value);
                    });

                    $.each(urlParams, function(paramName, urlParamName) {
                        var urlParamValue = aswparam.getURLParameter(urlParamName);

                        if (urlParamValue) {
                            urlBag.addValue(paramName, urlParamValue);
                        }
                    });

                    this.updateLinks();
                }
            }
        },
        updateLinks: function(){
            var aswparam = this;

            // Web page
            $('a').each(function() {
                var link = aswparam.linkDecorator(this.href);
                // Decorate only cart links.
                if(link){
                    this.href = link;
                }
            });
            // INTs, LPs
            $('.choice', '.selection').each(function() {
                var input = $(this).find('input[type=radio]');
                var link = aswparam.linkDecorator(input.val());
                if(link){
                    input.val(link);
                }
            });
            // for dynamically loaded prices
            if (!this.inited) {
                // TODO: Remove 'avast.ab.updatePrice', 'avast.bab.updatePrice' events, when all triggers replaced with 'priceUpdate.ab.avast'.
                $(document).on('priceUpdate.ab.avast avast.ab.updatePrice avast.bab.updatePrice', function() {aswparam.updateLinks();});
                this.inited = true;
            }
        },
        getCookieValue: function(name) {
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            return (parts.length >= 2) ? parts.pop().split(';').shift() : null;
        },
        getURLParameter: function(name) {
            return decodeURI((RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]);
        },
        linkDecorator: function(link){
            var href;
            var urlBagEncodedData = urlBag.getEncodedData();

            if (urlBagEncodedData) {
                $.each(this.cartLinks, function (provider, providerDef) {
                    $.each(providerDef.urls, function (key, providerUrl) {
                        if (link.indexOf(providerUrl) != -1) {
                            if (link.search(providerDef.paramRegex) > -1) {
                                href = link.replace(providerDef.paramRegex, '$1' + urlBagEncodedData);
                            } else {
                                href = link.replace(providerDef.appendBeforeRegex, providerDef.paramPattern.replace('%urlBagValue%', urlBagEncodedData) + '$1');
                            }
                        }
                    });
                });
            }
            return href;
        },
        getClientInfo: function(paramName, cookieName){
            var client = (window.avastGlobals && window.avastGlobals.client) ? window.avastGlobals.client : null,
                value;

            if(client){
                value = (client[paramName] === 'null') ? null : client[paramName];
            } else {
                value = this.getCookieValue(cookieName + '-i') ? this.getCookieValue(cookieName + '-i') : this.getCookieValue(cookieName);
            }

            return value;
        },
        updateAswparamPlaceholderLinks: function(globalCartLinks, aswparamValue) {
            const linkAswparamPlaceholder = '{aswparam}';
            var newLink,
                cartLinks = [];

            $('a').not('a[href^="#"]').each(function() {
                var el = this;
                var link = el.href;
                $.each(globalCartLinks, function (provider, providerUrl) {
                    if (link.indexOf(providerUrl) != -1) {
                        cartLinks.push(el);
                    }
                });
            });

            $.each(cartLinks, function (el, link) {
                if(aswparamValue && $(this).data('aswparam-placeholder')) {
                    var elDataAswparamPlaceholder = $(this).data('aswparam-placeholder');
                    aswparam = elDataAswparamPlaceholder.replace('{ASWPARAM}', aswparamValue);

                    if (link.href.indexOf(linkAswparamPlaceholder) != -1 || link.href.indexOf(escape(linkAswparamPlaceholder) != -1)) {
                        newLink = link.href.indexOf(escape(linkAswparamPlaceholder)) != -1 ? link.href.replace(escape(linkAswparamPlaceholder), aswparam) : link.href.replace(linkAswparamPlaceholder, aswparam);

                        $(link).attr('href', newLink);
                    }
                } else {
                    newLink = link.href.indexOf(escape(linkAswparamPlaceholder)) != -1 ? link.href.replace(escape(linkAswparamPlaceholder), '') : link.href.replace(linkAswparamPlaceholder, '');

                    $(link).attr('href', newLink);
                }
            });

        }
    };

    return aswparam;

})());

/**
 * Wrapper for cookieStorage object
 * @version 1.1.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.storage.cookieStorage
 * @requires avast.storage.isCookieEnabled
 * @requires avast.storage.storageFactory
 */
avm.define('avast.storage.cookieStorage', (function() {
	'use strict';
	var isCookieEnabled = avm.require('avast.storage.isCookieEnabled'),
		storageFactory = avm.require('avast.storage.storageFactory'),
		toString = Object.prototype.toString,
		keys = function() {
			return document.cookie.replace(/((?:^|\s*;)[^=]+)(?=;|$)|^\s*|\s*(?:=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:=[^;]*)?;\s*/);
		},
		cookieStorage = {
			length: document.cookie !== '' ? keys().length : 0,

			/**
			 * Add key/value pair
			 * @param {*} key
			 * @param {*} value
			 * @param {string|date} [expires]
			 * @param {string} [path]
			 * @param {string} [domain]
			 * @param {boolean} [secure]
			 */
			setItem: function(key, value, expires, path, domain, secure) {
				if (typeof key !== 'undefined' && typeof value !== 'undefined') {
					var regExp = /^(?:expires|max\-age|path|domain|secure)$/i;
					key = encodeURIComponent(key);
					value = encodeURIComponent(value);
					if (key && !regExp.test(key)) {
						if (document.cookie.indexOf(key) === -1) {
							this.length++;
						}
						if (typeof expires === 'string') {
							expires = '; expires=' + expires;
						} else if (toString.call(expires) === '[object Date]') {
							expires = '; expires=' + expires.toUTCString();
						}
						document.cookie = key + '=' + value + (typeof expires === 'string' ? expires : '') + (typeof domain === 'string' ? '; domain=' + domain : '') + (typeof path === 'string' ? '; path=' + path : '') + (secure ? '; secure' : '');
					}
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.setItem');
				}
			},

			/**
			 * Get value associated with key
			 * @param {*} key
			 * @returns {string|null}
			 */
			getItem: function(key) {
				if (typeof key !== 'undefined') {
					var regExp = new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(key).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$');
					return decodeURIComponent(document.cookie.replace(regExp, '$1')) || null;
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.getItem');
				}
			},

			/**
			 * Remove key/value pair
			 * @param {*} key
			 * @param {string} [path]
			 * @param {string} [domain]
			 */
			removeItem: function(key, path, domain) {
				if (typeof key !== 'undefined') {
					key = encodeURIComponent(key);
					if (document.cookie.indexOf(key) !== -1) {
						this.length--;
					}
					document.cookie = key + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' + (typeof domain === 'string' ? '; domain=' + domain : '') + (typeof path === 'string' ? '; path=' + path : '');
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.removeItem');
				}
			},

			/**
			 * Get name of nth key
			 * @param {number} n
			 * @returns {string}
			 */
			key: function(n) {
				if (typeof n === 'number') {
					var keysArray = keys(),
						keysArrayLength = keysArray.length;
					if (n < keysArrayLength) {
						return decodeURIComponent(keysArray[n]);
					} else {
						return null;
					}
				} else {
					throw new Error('Invalid method arguments to avast.storage.cookieStorage.key');
				}
			},

			/**
			 * Clear all items
			 */
			clear: function() {
				var keysArray = keys(),
					keysArrayLength = keysArray.length;
				for (var i = 0; i < keysArrayLength; i++) {
					this.removeItem(keysArray[i]);
				}
				this.length = document.cookie !== '' ? keys().length : 0;
			}

		};
	return isCookieEnabled ? cookieStorage : storageFactory();
})());

/**
* Decorate cart link with showCuponeCode parameter 
* @version 1.1.3
* @author Ales Gabriel, Michal Langhoffer
* @module avast.web.couponCode
* @requires jquery
* @requires avast.storage.cookieStorage
*/
avm.define('avast.web.couponCode', (function () {
    'use strict';

    var $ = avm.require('jquery'),
        cookieStorage = avm.require('avast.storage.cookieStorage');
    
    return {
        options: {
           regexS: '[\\?&]couponfield=yes([^&#]*)',
           providers:['dr-store.avast.com','store.avast.com','store.avast.ru'],
           urlQuery: '/showCouponCode=yes'
         },

         init: function(params){
            var root = this;
            if(params !== undefined){
                for(var param in params){
                    this.options[param] = params[param];
                }
            }

            var regex = new RegExp(this.options.regexS,"i");
            var results = regex.exec(window.location.href);

            if(results === null){
                return 1;
            } else {
                var href;
                var couponParam = this.options.urlQuery;
                var providers = this.options.providers;
                var cookieExpirationTime = new Date();

                function getHostname() {
                    var hostnameSplitted = window.location.hostname.split('.');

                    if (hostnameSplitted[hostnameSplitted.length - 2] === 'avast' && hostnameSplitted[hostnameSplitted.length - 1] === 'com') {
                        return '.avast.com';
                    } else {
                        return window.location.hostname.substring(3);
                    }
                }

                $("a").each(function(){
                    href = $(this).attr('href') ? $(this).attr('href') : "";
                    for(var i=0;i<providers.length;i++){
                        if(href.indexOf(providers[i]) != -1 && href.indexOf(couponParam) == -1){
                            href = href + couponParam;
                            $(this).attr('href',href);
                        }
                    }
                });

                cookieExpirationTime.setMonth(cookieExpirationTime.getMonth() + 2); // expiration set to 2 months
                cookieStorage.setItem('couponfield', 'yes', cookieExpirationTime, '/', getHostname());
            }
         }
     };
})());

/**
 * Browser and OS detection
 * @version 1.4.0
 * @author Jiri Duchon <duchon@avast.com>
 * @module avast.detect
 * @requires avast.storage.isCookieEnabled
 * @requires avast.storage.isStorageEnabled
 * @param {string} [userAgent]
 * @param {string} [userLanguage]
 * @param {Object} [patterns]
 * @returns {Object}
 */
avm.define('avast.detect', function(userAgent, userLanguage, patterns) {
	'use strict';
	var isCookieEnabled = avm.require('avast.storage.isCookieEnabled'),
		isStorageEnabled = avm.require('avast.storage.isStorageEnabled'),
		toString = Object.prototype.toString,
		hasOwnProperty = Object.prototype.hasOwnProperty;
	userAgent = typeof userAgent === 'undefined' ? navigator.userAgent || (typeof navigator.appCodeName === 'string' && typeof navigator.appVersion === 'string' ? navigator.appCodeName + '/' + navigator.appVersion : '') : userAgent;
	userLanguage = typeof userLanguage === 'undefined' ? navigator.userLanguage || navigator.language || '' : userLanguage;
	patterns = typeof patterns === 'undefined' ? {
		browser: {
			Avast: {
				name: /avastium|avast|avg/,
				version: /(?:avastium\s\()(\d+(?:\.\d+)+)|\s(avast|avg)\/\K(\d+(?:\.\d+)+)/
			},
			Opera: {
				name: /opr|opera/,
				version: /(?:opr\/|opera(?:\s|\/)|version\/)(\d+(?:\.\d+)+)/
			},
			Edge: {
				name: /edge/,
				version: /(?:edge\/(\d+(?:\.\d+)+))/
			},
			EdgeChromium: {
				name: /edg/,
				version: /(?:Edg\/(\d+(?:\.\d+)+))/
			},
			Chrome: {
				name: /chrome|crios|crmo/,
				version: /(?:chrome|crios|crmo)\/(\d+(?:\.\d+)+)/
			},
			Firefox: {
				name: /firefox|iceweasel/,
				version: /(?:firefox|iceweasel)\/(\d+(?:\.\d+)+)/
			},
			InternetExplorer: {
				name: /msie|trident/,
				version: /(?:rv:|msie\s)(\d+(?:\.\d+)+)/
			},
			Safari: {
				name: /safari/,
				version: /(?:version|safari)\/(\d+(?:\.\d+)+)/
			}
		},
		os: {
			WindowsPhone: {
				name: /windows phone/,
				version: /windows\sphone\s(?:os\s)?(\d+(?:\.\d+)+)/
			},
			Windows: {
				name: /windows/,
				version: {
					10: /windows nt 10.0/,
					8.1: /windows nt 6.3/,
					8: /windows nt 6.2/,
					7: /windows nt 6.1/,
					Vista: /windows nt 6.0/,
					XP: /windows nt (?:5.1|5.2)/,
					2000: /windows nt 5.0/
				}
			},
			Android: {
				name: /android/,
				version: /android\s(\d+(?:\.\d+)+)/
			},
			IOS: {
				name: /iphone|ipad|ipod/,
				version: /cpu\s(?:iphone\s)?os\s(\d+(?:_\d+)+)/
			},
			Mac: {
				name: /mac/,
				version: /mac\sos\sx\s(\d+(?:_\d+)+)/
			},
			Linux: {
				name: /linux/,
				version: /linux\s([^;]+)/
			},
			Unix: {
				name: /x11/,
				version: /x11;\s(?:u;)?([^;]+)/
			}
		}
	} : patterns;
	if (typeof userAgent === 'string' && typeof userLanguage === 'string' && typeof patterns === 'object' && patterns && typeof patterns.browser === 'object' && patterns.browser && typeof patterns.os === 'object' && patterns.os) {
		var results = {
				browser: {
					userAgent: userAgent.toLowerCase(),
					userLanguage: userLanguage.toLowerCase(),
					isCookieEnabled: isCookieEnabled,
					isStorageEnabled: isStorageEnabled,
					name: '',
					version: ''
				},
				os: {
					name: '',
					version: ''
				}
			},
			testRegExp = function(subPatterns, subResults) {
				var name = '',
					isName = '',
					version,
					subversion,
					nameFound = false,
					subversionFound = false;
				for (var subPattern in subPatterns) {
					if (hasOwnProperty.call(subPatterns, subPattern)) {
						name = subPatterns[subPattern].name;
						version = subPatterns[subPattern].version;
						isName = 'is' + subPattern;
						if (!nameFound && name.test(results.browser.userAgent)) {
							subResults.name = subPattern;
							subResults[isName] = true;
							if (toString.call(version) === '[object RegExp]' && version.test(results.browser.userAgent)) {
								subResults.version = results.browser.userAgent.match(version)[1];
							} else if (toString.call(version) === '[object Object]') {
								for (var item in version) {
									if (!subversionFound && hasOwnProperty.call(version, item)) {
										subversion = version[item];
										if (toString.call(subversion) === '[object RegExp]' && subversion.test(results.browser.userAgent)) {
											subResults.version = item;
											subversionFound = true;
										}
									}
								}
							}
							nameFound = true;
						} else {
							subResults[isName] = false;
						}
					}
				}
			};
		testRegExp(patterns.browser, results.browser);
		testRegExp(patterns.os, results.os);
		return results;
	} else {
		throw new Error('Invalid method arguments to avast.detect');
	}
});

/**
 * download-popup
 * @version 0.0.3
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.downloadPopup
 * @requires module:jquery|cash
 * @copyright Avast Software s.r.o &copy;2015
 */
avm.define('avast.web.downloadPopup', function() {
	'use strict';

	var $ = avm.require('jquery');

	var downloadPopup = {
		init: function(conf) {
			var defaults = {
					popup: '[data-download-popup]',
					openBtn: '[data-behavior="download-popup"]',
					closeBtn: '[data-behavior-dismiss="download-popup"]',
					context: 'body',
					exitIntent: false
				},
				config = $.extend(defaults, conf),
				$popup = $(config.popup);

			downloadPopup.config = config;

			// console.log('Popup is: %s', config.popup);
			// register events
			if ($popup.length) {
				$(config.context).on('click', config.openBtn, function(e) {
					$popup.css('display', ''); // default state is display none on inline styles.
					$popup.outerWidth(); // Reflow
					$popup.addClass('is-open');

				});
				$(config.context).on('click', config.closeBtn, function(e) {
					$popup.removeClass('is-open');
				});
			}

			// Reveal browser dependent content
			downloadPopup.switchBrowser();

			if (config.exitIntent) {
				$popup.on('mouseover', config.closeBtn, downloadPopup.closeBtnHandler);
				$popup.on('mouseout', downloadPopup.mouseoutHandler);
			}

			return $popup.length;
		},
		exitIntentHandler: function(e) {
			var target = $(downloadPopup.config.popup);

			if (target) {
				target.addClass('is-exit-intent');
			}
		},
		closeBtnHandler: function(e) {
			downloadPopup.exitIntentHandler(e);
			$(e.currentTarget).off('mouseover', downloadPopup.closeBtnHandler);
		},
		mouseoutHandler: function(e) {
			if (downloadPopup.config.exitIntent && e.toElement === null && e.relatedTarget === null) {
				// Mouse reaches top of the window
				if (e.clientY <= 0) {
					// Run only once
					downloadPopup.config.exitIntent = false;
					downloadPopup.exitIntentHandler(e, downloadPopup.config.popup);
					$(e.currentTarget).off('mouseout', downloadPopup.mouseoutHandler);
				}
				// Mouse reaches bottom of the window
				if (e.clientY >= window.innerHeight) {
					downloadPopup.config.exitIntent = false;
					$(e.currentTarget).off('mouseout', downloadPopup.mouseoutHandler);
					$(downloadPopup.config.popup).off('mouseover', downloadPopup.closeBtnHandler);
				}
			}
		},
		switchBrowser: function(browserObj) {
			var detect = avm.require('avast.detect')(),
				browser = browserObj || detect.browser;

			if (browser.isChrome || browser.isAvast || browser.isEdgeChromium) {
				$('[data-browser]').css('display', 'none');
				$('[data-browser="chrome"]').css('display', '');
			} if (browser.isFirefox || browser.isOpera || browser.isSafari) {
				$('[data-browser]').css('display', 'none');
				$('[data-browser="firefox"]').css('display', '');
			}
			if (browser.isEdge || browser.isInternetExplorer) {
				$('[data-browser]').css('display', 'none');
				$('[data-browser="ie"]').css('display', '');
			}

			return browser.name;
		}
	};

	return downloadPopup;
});

/**
 * Decorate link with params
 * @version 1.1.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.linkdecorator
 * @requires jquery
 * @requires avast.url.unserialize
 * @param {string} selector Css selector. Matched elements will be decorated
 * @param {(string|string[])} params Name or array of names
 * @param {string} [querystring] Optionally you can set querystring parameter manually. In this case querystring from URL will be ignored.
 * @param {string} [newValue] Optionally value can be set
 * @returns {object} jQuery object of selected elements
 */

avm.define('avast.web.linkDecorator', function(selector, params, querystring, newValue){
	'use strict';

	var $ = avm.require('jquery'),
		query = querystring ? querystring : undefined,
		unserialize = avm.require('avast.url.unserialize'),
		urlParams = unserialize(query),
		paramArr = (Object.prototype.toString.call(params) === '[object Array]') ? params : [params],
		param = null,
		$els = null,
		result = [];

	for (var i = 0; i < paramArr.length; i++ ) {
		param = paramArr[i];

		if(urlParams[param]){
			$els = $(selector).each(function () {
				var $el = $(this),
					prepend = this.search && this.search.length > 0 ? '&' : '?',
					hrefParams = unserialize($el.attr('href')),
					value = newValue || urlParams[param];

				if(!hrefParams[urlParams[param]]){
					$el.attr('href', $el.attr('href') + prepend + param + '=' + value );
				}
			});
			result.push($els)
		}
	}

	return result;
});
/**
 * Setup tasks for elements with declared behavior (data-behavior).
 * Name of the task must much to data-behavior prefix.
 * Run Scanner with init({config}) method.
 * @version 0.0.3
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.linkScanner
 * @requires module:jquery|cash
 * @copyright Avast Software s.r.o &copy;2015
 */
avm.define('avast.web.linkScanner', function() {
	'use strict';

	var $ = avm.require('jquery'),
		downloadPopup = avm.require('avast.web.downloadPopup'),
		browserDetect = avm.require('avast.detect')();
	var tasks = {

		/**
		 * downloadPopup Update download link with direct download [data-behavior~="downloadPopup"] atrribute
		 * @param {HTMLElement} el element to update download link
		 * @returns {Array} Array of HTMLElements
		 */
		downloadPopup: function(el) {
			var downloadNames = ['FAV-'],
				downloadName = el.dataset.downloadName || '',
				downloadNameMatch,
				role = el.dataset.role || '',
				url,
				params,
				dlPopup,
				popup,
				result;

			// Test if download name matches to suffix
			downloadNames.forEach(function(needle) {
				var match = downloadName.lastIndexOf(needle, 0) === 0;

				downloadNameMatch = match;
			});

			// console.log('downloadNameMatch ' + downloadNameMatch);

			// Update download links for FAV-ONLINE, FAV-ONLINE-XXX to direct download.
			if (el.href && role === 'download-link' && downloadNameMatch) {
				url = new URL(el.href);
				params = url ? url.searchParams : null;

				// Update with direct download only if popup available on page

				// Init download popup only for FAV-ONLINE and FAV-ONLINE-xxx download buttons
				dlPopup = downloadPopup();
				if(!browserDetect.browser.isEdge && !browserDetect.browser.isInternetExplorer) {
					popup = dlPopup.init({
						popup: '#downloadPopup',
						openBtn: 'a[data-role="download-link"][data-download-name^="FAV-"]:not([data-behavior="downloadPage"]):not([data-download-name*="WEBSITE-"])',
						closeBtn: '.js-dtp-close' // TODO: use data attributes in DOM
					});
				}

				//console.log(popup);
				// Update href parameters for direct download
				if (popup > 0 && !browserDetect.browser.isEdge && !browserDetect.browser.isInternetExplorer) {
					params.set('direct', 1);
					url.search = params.toString();
					result = el.href = url.toString();
				}
			}

			return result;
		}
	};

	var scanner = {

		/**
		 * init Start scanning
		 * @param {Object} [conf] Config object
		 * @param {string[]} conf.tasks Define which tasks should run.
		 * @param {HTMLElement|string} conf.context Set parent which child should be scanned.
		 */
		init: function(conf) {

			var defaults = {
					context: document.body
				},
				config = $.extend(defaults, conf),
				items = config.tasks || Object.keys(tasks);

			items.forEach(function(task) {
				// Apply task if task's name match the data-behavior value prefix (before first -)
				var behaviorSelector = '[data-behavior~="' + task + '"]', // always run tusks for elements with behavior defined
					configSelectors = config.selectors,
					selector = behaviorSelector;

				// Additionaly run tasks for elements specified in config object
				if (configSelectors.length) {
					selector = behaviorSelector + ',' + configSelectors.join(',');
				}

				$(config.context).find(selector).each(function() {
					if (tasks[task] && typeof tasks[task] === 'function') {
						tasks[task](this);
					}
				});
			});
		}
	};

	return scanner;
});

/**
 * Tracking for Mobile Campaigns
 * @version 1.0.2
 * @author Fedor Kušš <fedor.kuss@avast.com>
 * @module avast.web.mobileTracking
 * @requires jquery
 * @requires avast.url.unserialize
 */

(function() {
	'use strict';
	var urls =
	['index', 'free-mobile-security', 'free-ios-security', 'lp-ppc-protect-a', 'lp-ppc-protect-b', 'secureline-vpn', 'lp-ppc-secureline-vpn-buy','lp-protection','protection'],
		pathName = window.avastGlobals.web.fileName;

	if (urls.indexOf(pathName) > -1) {

		var unserializedUrl = avm.require('avast.url.unserialize')(),
			cmpgContent = unserializedUrl.cmpg_for_af;

		if (typeof cmpgContent !== 'undefined' && cmpgContent.length > 0) {

			var detected = avm.require('avast.detect')();

			if (detected.os.isAndroid || detected.os.isIOS) {
				$('body').addClass('mobile-tracking');
				var mobileTracking = $('.mobile-tracking .bi-download-link');

				mobileTracking.attr('href', 'https://go.onelink.me/gM36?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2Fwww.avast.com%2Ffree-mobile-security');

				if (pathName === 'secureline-vpn') {
					mobileTracking.attr('href', 'https://go.onelink.me/KhNk?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2Fwww.avast.com%2Fsecureline-vpn');

				}
				if (pathName === 'lp-ppc-secureline-vpn-buy') {
					mobileTracking.attr('href', ' https://go.onelink.me/KhNk?pid=AdWords-Web&c=' + cmpgContent + '&af_web_dp=https%3A%2F%2Fwww.avast.com%2Fsecureline-vpn');
				}
				if (pathName === 'lp-safe-emailing') {
					mobileTracking.attr('href', 'https://avast.sng.link/Dp3jo/4129/jvio');
				}
			}
		}
	}
})();

/**
 * Navigation - global navigation
 * @version 1.4.0
 * @author Michal Langhoffer <langhoffer@avast.com>, Ales Gabriel <gabriel@avast.com>, Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.navigation
 * @requires jquery
 * @requires avast.url.unserialize
 * @requires avast.web.mqMarker
 * @return {Function} Emitter constructor
 */


var avast = avast || {};

// Disables language selector
avast.disableLanguageSelector = true;

/**
 * Definiton of modules for 'avast.web.navigation'
 */
avm.define('avast.web.navigation', function (navSel) {
	'use strict';

	// Required modules
	var $ = avm.require('jquery'),
		unserialize = avm.require('avast.url.unserialize'),
        setMqMarkers = avm.require('avast.web.mqMarker');


//--------------------------------- Communal ---------------------------------

    // Universal Selectors
	var $window = $(window),
		$body = $('body'),
		$navigation = navSel ? $(navSel) : $('.js-navigation-oo-19798'),
		$secondMenuBlogs = document.querySelector('.second-menu.blogs'),
		$langSelector = $('.region-selector'),
		$languageSelectorButtons = $('.js-language-selector-trigger'),
		$languageSelector = $langSelector.find('.region-selector-close');


    // Universal variables
	var firstMenuClasses = getFirstMenuClasses(),
		secondMenuClasses = getSecondMenuClasses(),
		openedThirdMenu,
		thirdMenuLinks = [],
		openedSubMenu,
		languageSelectorTrigger,
		avastGlobalsAvailable = typeof window.avastGlobals !== 'undefined' && typeof window.avastGlobals.web !== 'undefined',
        isDevEnv = avastGlobalsAvailable ? window.avastGlobals.web.domain.split('/').length > 1 : false,
        config = { firstMenu: false, secondMenu: false },
        navInit = { desktopNav: false, mobileNav: false };

	/**
     * Get all 1st menu classes to an array
     */
	function getFirstMenuClasses() {
		var classes = [];
		var firstMenuItems = document.querySelectorAll('.first-menu .item:not(.blogs)');

		firstMenuItems.forEach(function (el) {
			var itemData = el.getAttribute('data-first-menu');

			if (itemData) {
				var itemClass = 'first-menu-' + itemData;
				classes.push(itemClass);
			}
		});

		return classes;
	}

	/**
     * Get all 2nd menu classes to an array
     */
	function getSecondMenuClasses() {
		var classes = [];
		var secondMenuItems = document.querySelectorAll('.second-menu li');

		secondMenuItems.forEach(function (el) {
			var itemData = el.getAttribute('data-second-menu');

			if (itemData) {
				var itemClass = 'second-menu-' + itemData;
				classes.push(itemClass);
			}
		});

		return classes;
	}

    /**
     * Detects platform, compose the platform class name and insert the class name to the 'body'
     */
	function detectedPlatfromToBodyClass() {
		var detectedPlatform = avm.require('avast.detect')().os;
		$body.addClass('platform-' + detectedPlatform.name.toLowerCase());
	}

	detectedPlatfromToBodyClass();

	// Determines whether desktop / mobile navigation should be shown
    var mqMobile = window.matchMedia('(max-width: 992px)'),
		mqDesktop = window.matchMedia('(min-width: 992px)');

	/**
	 * Extracts the value of ':before' class from the 'body' and if the navigation is viewed from desktop, returns 'navigation-desktop', if from mobile, returns 'none'
 	 */
	function isDesktop() {
		var mq = (window.getComputedStyle) ? window.getComputedStyle(document.body, ':before').getPropertyValue('content') : '';
		return mq.indexOf('navigation-desktop') > -1 ? true : false;
	}

	// Changes to desktop / mobile navigation on resize
	if (isDesktop()) {
			desktopNav();
			$(window).on('resize', setDesktopNav);
			setMqMarkers('mq-desktop', 'header nav');
	} else {
		mobileNav();
		$(window).on('resize', setMobileNav);
		$(window).on('load', setMobileNav);
		setMqMarkers('mq-mobile', 'header nav');
	}

	// Communal 1st menu

	/**
	 * Clears all 1st menu classes
	 */
	function clearFirstMenuClasses() {
		config.firstMenu = false;
		$body.removeClass(firstMenuClasses.join(' '));
	}

	// Communal 2nd menu

	/**
	 * Clears all 2nd menu classes
	 */
	function clearSecondMenuClasses() {
		config.secondMenu = false;
		$body.removeClass(secondMenuClasses.join(' '));
	}

	/**
	 * Collects all classes of the 2nd menu, composes them together with one space between and adds them to the 'body'
	 */
	function expandSecondLevel() {
		var classes = secondMenuClasses.join(' ');
		config.secondMenu = classes;
		updateNavigation();
	}

	/**
	 * Detects, on which 2nd menu item was clicked and adds its class on 'body'
	 */
	function openSecondMenu($element, event) {
		var cachedSecondMenu = config.secondMenu,
			clickedSecondMenu = 'second-menu-' + $element.data('second-menu');


		if (isDesktop()) {

			clearSecondMenuClasses();

		} else {

			if (cachedSecondMenu.split(' ').length > 1) {

				 // If the class is already there, removes it
				 if (cachedSecondMenu.indexOf(clickedSecondMenu) > -1) {
				 config.secondMenu = removeSpaces(cachedSecondMenu.replace(clickedSecondMenu, ''));
				 }

				 // Else adds it
				 else {
					config.secondMenu = removeSpaces(cachedSecondMenu + ' ' + clickedSecondMenu);
				}

				updateNavigation('toggle', clickedSecondMenu);
				return;
			}
		}

		// If the same menu was not clicked, then sets 2nd menu as a current menu
		if (clickedSecondMenu !== cachedSecondMenu) {
			config.secondMenu = clickedSecondMenu;
		}

		updateNavigation();
	}

	// Communal Third menu

	/**
	 * Collects all the links from element and if they are not hidden, creates an array from them in the 3rd menu
	 */
	function defInnerLinks(parent) {
		var menuLinks = parent.querySelectorAll('a');

		menuLinks.forEach(function (el) {
			if (!isHidden(el)) {
				thirdMenuLinks.push(el)
			}
		});

		openedThirdMenu = parent;
	}

	/**
	 * Removes 'aria-expanded' attribute and 'isOpen' class from the expanded 3rd menu
	 */
	function removeExpanded() {
		var menuOpened = document.querySelector('[aria-expanded=true]'),
			menuOpenedClass = document.querySelectorAll('.second-menu .isOpen');

		menuOpened !== null ? menuOpened.setAttribute('aria-expanded', false) : '';
		menuOpenedClass.forEach(function(item) {
			item.classList.remove('isOpen');
		})

	}

	// Communal Regions

	function closeRegionModal() {
		$langSelector.removeClass('active');
		$('body').removeClass('js-language-selector-open');
		$body.removeClass('first-menu-regions');

		closeSubMenus();

		// Sets focus on a Region selector
		languageSelectorTrigger.focus()
	}


	// Closes the Region selector after clicking on a language
	$languageSelector.on('click', closeRegionModal);

	// Closes the 'blogs-special-menus' after clicking on 'regions' and adds the 'first-menu-regions' class on the 'body'
	$languageSelectorButtons.on('click', function () {
		$body.removeClass('blogs-special-menu');
		languageSelectorTrigger = $(this)[0];

		// Toggles on desktop, because 1st levels are disabled
		$body.addClass('first-menu-regions');
		document.querySelector('.region-selector').setAttribute('aria-expanded', true);
		$langSelector.addClass('active');
		$('body').addClass('js-language-selector-open');
		window.history.pushState({ 'avast_regions': true }, 'Avast regions', window.location.href);
	});

	window.addEventListener('popstate', closeRegionModal, false);

	/**
     * Closes all the open submenus
     */
	function closeSubMenus() {
		isDesktop() ? clearSecondMenuClasses() : "";
		removeExpanded();
		$body.removeClass('navigation-search-opened');
		$body.removeClass('js-language-selector-open');
		$body.removeClass('first-menu-regions');
		$body.removeClass('blogs-special-menu');
		$langSelector.removeClass('active');
		openedThirdMenu = null;
	}

	/**
     * Checks, if a menu item is hidden
     */
	function isHidden(el) {
		while (el) {
			if (el === document) {
				return false;
			}
			var $style = window.getComputedStyle(el, null);
			if (!el) {
				return true;
			} else if (!$style) {
				return true;
			} else if ($style.display === 'none') {
				return true;
			} else if (($style.display === 'block' || $style.display === 'inline-block') && $style.height === '0px' && $style.overflow === 'hidden') {
				return true;
			} else {
				return $style.position === 'fixed' || isHidden(el.parentNode);
			}
		}
	}

	/**
     * Update of navigation
     */
	function updateNavigation(data, toggleClass) {

		// Resets the navigation to the default state
		if (data === 'reset') {
			$body.removeClass('blogs-special-menu');

			if (!isDesktop()) {
				$body.addClass('navigation-closed');

			} else {
				$body.removeClass('first-menu-regions');
			}

			return;
		}

		// Toggles adding / removing of class (which was input to second parameter) on 'body'
		if (data === 'toggle') {
			$body.toggleClass(toggleClass);
		}

		if (config.firstMenu) {
			$body.addClass(config.firstMenu);
		}

		if (config.secondMenu) {
			$body.addClass(config.secondMenu);
		}

		// Toggles adding / removing of 'blogs-special-menu' class on 'body' on mobile and removes all the classes of 1st menu
		if (data === 'open_blogs_special_menu') {

			if (!isDesktop()) {
				clearFirstMenuClasses();
				$body.toggleClass('blogs-special-menu');
			}

			$body.addClass(config.firstMenu);

		// If no parameter was inputed, remove the class 'blogs-special-menu'
		} else {
			$body.removeClass('blogs-special-menu');
		}
	}

	/**
     * Removes unnecessary spaces between words
     */
	function removeSpaces(str) {
		var strSplitted = str.split(' '),
			result = [];

		strSplitted.map(function (value) {
			if (value !== '') {
				result.push(value);
			}
		});

		return result.join(' ');
	}

//--------------------------------- Desktop ---------------------------------

    /**
     * Init if desktop and preselect levels only on www.avast domains
     */
	function desktopNav() {
		navInit.desktopNav = true;
		preSelectLevels();
		$body.addClass('navigation-for-desktop');

		// Desktop 2nd menu

		// Add and remove aria attibute
		document.querySelectorAll('[data-second-menu] .subcategory').forEach(function(item) {
			item.addEventListener('mouseenter', function() {
				item.setAttribute('aria-expanded', true);
			});

			item.addEventListener('mouseleave', function(e) {
				if (!$(document.elementFromPoint(e.clientX, e.clientY)).parents('.third-menu').length > 0) {
					item.setAttribute('aria-expanded', false);
					item.parentElement.classList.remove('isOpen');
				}
			})
		});

		document.querySelectorAll('.third-menu').forEach(function(item) {
			item.addEventListener('mouseleave', function (e) {
				if (!$(document.elementFromPoint(e.clientX, e.clientY)).parents('[data-second-menu]').length > 0) {
					item.previousElementSibling.setAttribute('aria-expanded', false);
					item.previousElementSibling.parentElement.classList.remove('isOpen')
				}
			})
		});

        // Opens up a menu item by pressing 'enter' key and closes all the open submenus
		$navigation.on('keyup', 'nav.mq-desktop [data-second-menu]', function (key) {
			if (key.which == 13 || key.keyCode == 13) {
				var menuElement = this.querySelector('div.third-menu');
				openedSubMenu = document.activeElement;
				closeSubMenus();
				$(this).children('span.subcategory').attr('aria-expanded', true);
				$(this).addClass('isOpen');
				//openSecondMenu($(this));
				setFocus(menuElement);
				defInnerLinks(menuElement);
			}
		});

		$(document).on('keydown', function (key) {

			// Closes menu by pressing 'esc' key
			if (key.which == 27 || key.keyCode == 27) {
				openedSubMenu !== null && openedSubMenu !== undefined ? openedSubMenu.focus() : '';
				removeExpanded();
				openedSubMenu = null;

				if (typeof (openedThirdMenu) !== 'undefined' && openedThirdMenu !== null) {
					openedThirdMenu = null;
					thirdMenuLinks = [];
				}

				closeSubMenus();
			}

			// Sets focus on the first element after pressing 'tab' key on the last element
			if (key.which === 9 || key.keyCode === 9) {

				if (typeof (openedThirdMenu) !== 'undefined' && openedThirdMenu !== null) {
					if ($(document.activeElement)[0].innerHTML === $(thirdMenuLinks.slice(-1))[0].innerHTML) {
						openedThirdMenu.focus();
					}
				}
			}
		});

		// Desktop Blogs menu

		// Opens the 'Blogs menu' while mousehover on the 'Blogs' link
		$navigation.on('mouseenter', 'nav.mq-desktop .js-blogs', function () {
			updateNavigation('open_blogs_special_menu');
			$body.addClass('blogs-special-menu');
			$body.removeClass('first-menu-regions');
			$secondMenuBlogs.setAttribute('aria-expanded', true);
		});

		// Opens up the 'Blogs menu' by pressing 'enter' key and closes all the open submenus
		$navigation.on('keydown', 'nav.mq-desktop .js-blogs', function (key) {
			if (key.which == 13 || key.keyCode == 13) {
				openedSubMenu = document.activeElement;
				closeSubMenus();
				$secondMenuBlogs.setAttribute('aria-expanded', true);
				updateNavigation('open_blogs_special_menu');
				$body.addClass('blogs-special-menu blogs-special-menu-isOpen');
				setFocus($secondMenuBlogs);
				defInnerLinks($secondMenuBlogs);
			}
		});

		// Closes the 'Blogs menu' on mouseleave
		$navigation.on('mouseleave', 'nav.mq-desktop .js-blogs', function (e) {
			if (document.elementFromPoint(e.clientX, e.clientY) === null || !document.elementFromPoint(e.clientX, e.clientY).classList.contains('second-menu', 'blogs')) {
				updateNavigation("reset");
				$secondMenuBlogs.setAttribute('aria-expanded', false);
			}
		})

		// Mouseleave not working preciselly in $cache, it's triggered in the middle of elements height.
		if ($secondMenuBlogs !== undefined && $secondMenuBlogs !== null) {
			$secondMenuBlogs.addEventListener('mouseleave', function (evt) {

				if (evt.target.matches('nav.mq-desktop .second-menu.blogs')) {
					updateNavigation('reset');
					$secondMenuBlogs.setAttribute('aria-expanded', false);
				}

			});
		}

		// Desktop Regions

		// Opens up the 'Region selector' after pressing 'enter' key and closes the 'blogs special menu'
		$languageSelectorButtons.on('keydown', function (key) {
			if (key.which == 13 || key.keyCode == 13) {
				openedSubMenu = document.activeElement;
				languageSelectorTrigger = $(this)[0];
				$body.removeClass('blogs-special-menu blogs-special-menu-isOpen');

				// Toggles on desktop, because 1st levels are disabled
				$body.addClass('first-menu-regions');
				$langSelector.addClass('active');
				$('body').addClass('js-language-selector-open');
				var menuElement = document.querySelector('.region-selector');
				thirdMenuLinks = Array.from(menuElement.querySelectorAll('a'));
				openedThirdMenu = menuElement;
				menuElement.setAttribute('aria-expanded', true);

				// Sets focus on the region selector
				setFocus(menuElement);

				window.history.pushState({ 'avast_regions': true }, 'Avast regions', window.location.href);
			}
		})
	}

	/**
     * Sets focus on the element
     */
	function setFocus(element) {
		element.setAttribute('tabIndex', -1);
		setTimeout(function() {
			element.focus();
		}, 300);
	}

	/**
     * Composes an URL address
     */
	function preSelectLevels() {
		var $navigationSecondMenuLinks = $navigation.find('.second-menu:not(.regions) a'),
			pageNotFound = true,

			// Path and Filename of the current page
			currentPage = window.location.pathname,

			// Part of an URL after the '?'
			currentPageParams = unserialize(window.location.search),

			// Current locale
			ulocale = '',
			separator;

		if (avastGlobalsAvailable) {

			// Fills up the variable with the locale and File name
			ulocale = window.avastGlobals.web.ulocale.replace('/', '');
			separator = ulocale.length > 0 ? '/' : '';
			currentPage = '/' + ulocale + separator + window.avastGlobals.web.fileName;
		}

		$navigationSecondMenuLinks.each(function () {
			detectLink($(this));
		});

		// If the URL starts with the word 'web', it is a preview link ('web-preview.ff.int.avast.com..')
		if (pageNotFound && (window.location.hostname.substr(0, 3) === 'www' || window.location.hostname.substr(0, 3) === 'web')) {

			// Activates 'For home' menu
			config.firstMenu = 'first-menu-for-home';
			$body.addClass(config.firstMenu);
		}

		// Set press.avast.com and higlight Press center item in the First and 2nd menu
		if (window.location.hostname === 'press.avast.com') {
			var $pressCenter = $("li[data-second-menu='press-center']");

			// Activates 'About us' menu
			config.firstMenu = 'first-menu-about-us';
			$body.addClass(config.firstMenu);
			$pressCenter.addClass('isActive');
		}

		// Sets blog.avast.com and activates Blogs 2nd menu
		if (window.location.hostname === 'blog.avast.com') {
			var $blogSecondMenu = $('div.second-menu.blog'),
				$blogMenu = $('li.js-blogs.blogs');

			// Activates 'Blogs' menu
			config.secondMenu = 'second-menu blog';
			$body.addClass(config.secondMenu);
			$blogSecondMenu.addClass('isActive');
			$blogMenu.addClass('isActive');
		}

		// Activates 'For partners' menu
		if (avastGlobals && avastGlobals.web && /PARTNERS/.test(avastGlobals.web.contentGroup.toUpperCase())) {
			clearFirstMenuClasses();
			config.firstMenu = 'first-menu-for-partners';
			$body.addClass(config.firstMenu);
		}

		// Activates 'For business' menu
		if (avastGlobals && avastGlobals.web && /SMB|BUSINESS/.test(avastGlobals.web.contentGroup.toUpperCase())) {
			clearFirstMenuClasses();
			config.firstMenu = 'first-menu-for-business';
			$body.addClass(config.firstMenu);
		}

		// Activates 'About Us' menu
		if (avastGlobals && avastGlobals.web && /OTHERS/.test(avastGlobals.web.contentGroup.toUpperCase())) {
			clearFirstMenuClasses();
			config.firstMenu = 'first-menu-about-us';
			$body.addClass(config.firstMenu);
		}

		function detectLink($element) {
			if (pageNotFound) {
				var selfHref = $element.attr('href'),
					selfHrefParams = getParamsFromHref(selfHref);

				// If isDevEnv, remove first part && first symbol in link is '/'
				if (isDevEnv && selfHref.split('')[0] === '/') {
					selfHref = '/' + selfHref.split('/').splice(2).join('/');
				}

				// If selfHref contains parameters AND current page pathname is equal to link pathname AND current page contains params
				if (typeof selfHrefParams !== 'undefined' && selfHref.split('?')[0] === currentPage && !$.isEmptyObject(currentPageParams)) {

					// Checks if the current page contains those parameters
					for (var key in selfHrefParams) {

						if (typeof currentPageParams[key] !== 'undefined' && currentPageParams[key] === selfHrefParams[key]) {
							pageNotFound = false;
							detectParent($element);
							return false;
						}
					}
				}

				if (currentPage === selfHref) {
					pageNotFound = false;
					detectParent($element);
					return false;
				}
			}
		}

		/**
     	* Takes the closest '.second-menu' item, finds out from which 1st menu section comes from ('For home', 'For business'..) and displays relevant menu
     	*/
		function detectParent($foundLinkElement) {
			var $parent = $foundLinkElement.closest('.second-menu'),
				$parentWithData = $foundLinkElement.closest('[data-second-menu]'),
				parentClasses = $parent.attr('class').split(' '),
				availableClasses = ['for-home', 'for-business', 'for-partners', 'about-us'],
				linkFoundInNavigation = false;

			$(parentClasses).each(function () {
				if (availableClasses.indexOf(this) > -1) {

					// Sets a menu item into a variable
					config.firstMenu = 'first-menu-' + this;
					linkFoundInNavigation = true;

					// Sets aria data attribut to the First level menu
					$('li.' + this + ' a').attr('aria-current', true);

					// current active 2nd menu, if exists
					if ($parentWithData.length > 0) {
						$parentWithData.addClass('isActive');
					}

					// current link in 2nd or 3rd menu
					$foundLinkElement.parent().addClass('isActive');

					return false;
				}
			});

			// If the respective 2nd menu was not found, sets to 'For home' (Adds the class 'first-menu-for-home')
			if (!linkFoundInNavigation) {
				config.firstMenu = 'first-menu-for-home';
			}

			$body.addClass(config.firstMenu);
		}

		/**
     	* Returns an array of parameters from the URL
     	*/
		function getParamsFromHref(href) {
			var result;

			result = href.split('#')[0];
			result = href.split('?')[1];

			return typeof result !== 'undefined' ? unserialize(result) : undefined;
		}

	}

	/**
	* setDesktopNav Switch all DOM elements to desktop navigation
	*/
	function setDesktopNav() {
		if (mqDesktop.matches) {
			var body = document.querySelector('body');

			// Sets event listeneres for the desktop navigation
			if (!navInit.desktopNav) desktopNav();

			// Mark interactive elements with correct media query class. Used for proper event delegation
			setMqMarkers('mq-desktop', 'header nav');

			// Rebind resize event for desktop breakpoint
			$(window).off('resize', setDesktopNav);
			$(window).on('resize', setMobileNav);

			preSelectLevels();

			// No need to rebind secondMenu handlers, it's already on init and delegated to media query class.
			// Remove first level navigation.
			body.classList.remove.apply(body.classList, firstMenuClasses);

			// Add correct body classes for mobile navigation
			body.classList.add('navigation-for-desktop');

			if (config.firstMenu) {
				body.classList.add(config.firstMenu);

			} else {
				body.classList.add('first-menu-for-home');
			}

			// Remove second level navigation. Dropdowns are hidden on desktop by default.
			body.classList.remove.apply(body.classList, secondMenuClasses);

			// Remove main mobile class and close navigation - sets only mobile state.
			body.classList.remove(
				'navigation-for-mobile',
				'navigation-closed'
			);

			$('header nav').css('max-height', '');

			// Reset 1st menu. Prevent to display multiple first levels if switching from opened mobile navigation.
			config.firstMenu = config.firstMenu || false;

			// Reset 2nd menu. Prevent to display multiple second levels on blogs mouseover after switching from mobile navigation.
			config.secondMenu = config.firstMenu || false;
		}
	}


//--------------------------------- Mobile ---------------------------------

	/**
     * Init if mobile
     */
	function mobileNav() {
		var $toggleMenu = $navigation.find('.js-toggle-menu'),
			$hintToggler = $navigation.find('.js-hint-toggler'),
			$hintClose = $navigation.find('.js-hint-close');

		navInit.mobileNav = true;
		expandSecondLevel();
		$body.addClass('navigation-for-mobile');
		$body.addClass('navigation-closed');

		// 'Go back' button
		$navigation.on('click', 'nav.mq-mobile .js-back', function () {
			clearFirstMenuClasses();

			if ($(this).hasClass('js-blog')) {
				$body.removeClass('blogs-special-menu');
			}
		});

		// 'Close' button
		$navigation.on('click', '.js-toggle-menu', function () {
			if ($body.hasClass('navigation-closed')) {
				var messageBar = $('.message-line').length !== 0 ? $('.message-line').innerHeight() : 0;
				var cookiesBanner = $('#onetrust-banner-sdk').length !== 0 ? $('#onetrust-banner-sdk').innerHeight() + 10 : 0;

				$('header nav').css('max-height', (window.innerHeight - messageBar - cookiesBanner) + 'px');
			} else {
				$('header nav').css('max-height', '')
			}

			$body.toggleClass('navigation-closed');
			$toggleMenu.attr('data-nav-mobile-toggle', $toggleMenu.attr('data-nav-mobile-toggle') === 'open' ? 'closed' : 'open');
		});

		// Closes the menu if clicked elsewhere
		$window.on('click', function (event) {
			var $target = $(event.target);

			// If navigation clicked AND target is not special menu AND target is not Blogs item, then close special menu
			if ($target.closest($navigation).length > 0 ) {

				if (!isDesktop() && $target.is($navigation)) {
					updateNavigation('reset');
				}

			} else {

				// if cookie bar clicked, region selector button in footer, do not close
				if (!($target.is('.js-cookie-bar, .select-region-button, .select-region-button *') || $target.closest('.js-cookie-bar').length > 0)) {
					updateNavigation('reset');
				}
			}
		});

		// DataLayer push on click
		$navigation.on('click', 'nav.mq-mobile [data-bi-nav]', function () {
			if (typeof window.dataLayer !== "undefined") {
				window.dataLayer.push({
					event: 'firstMenuClick',
					button: this.getAttribute('data-bi-nav')
				});
			}
		});

		// Mobile 1st menu

		// Redirects to the correct URL after clicking on a 1st menu item (<a> link is not visible on mobile version of the menu)
		$navigation.on('click', 'nav.mq-mobile [data-first-menu]', function () {
			var cachedFirstMenu = config.firstMenu,
				clickedFirstMenu = 'first-menu-' + $(this).data('first-menu');

			if (this.getAttribute('data-first-menu') === 'for-business' && document.querySelector('.second-menu.for-business') === null) {
				window.location.href = this.querySelector('a').getAttribute('href');
			}

			clearFirstMenuClasses();

			if (clickedFirstMenu !== cachedFirstMenu) {
				config.firstMenu = clickedFirstMenu;
			}

			updateNavigation();
		});

		// Mobile 2nd menu

		// Detects, on which 2nd menu item was clicked and adds its class on 'body'
		$navigation.on('click', 'nav.mq-mobile [data-second-menu] span', function (event) {
			var menuItem = $(this).parent('li');
			openSecondMenu(menuItem, event);
		});

		// Toggles opening and closing of submenu in 'Security' mobile menu by adding / removing the class 'show-hint'
		$hintToggler.on('click', function () {
			$(this).closest('.js-hint').addClass('show-hint');
		});

		$hintClose.on('click', function () {
			$(this).closest('.js-hint').removeClass('show-hint');
		});


		// Mobile Blogs menu

		// Opens 'special menu' after clicking on 'Blogs' menu item
		$navigation.on('click', 'nav.mq-mobile .js-blogs', function () {
			updateNavigation('open_blogs_special_menu');
		});

		// Mobile region selector

		// Dropdowns control
		$('.js-regions-toggle').on('click', function () {
			var $regionList = $(this).closest('.area');

			$regionList.toggleClass('isOpen');
		});

		// Toggles showing/hiding of login buttons
		$('.header .second-menu .subcategory.account').on('click', function () {
			$('.third-menu.login').toggleClass('isOpen');
			$('.second-menu.for-business .mobile-links-top').toggleClass('isOpen');
		});

	}

	/**
     * setMobileNav Switch all DOM elements to mobile navigation
     */
	function setMobileNav() {
		if (mqMobile.matches) {
			var body = document.querySelector('body');

			// Sets event listeners for the mobile navigation
			if (!navInit.mobileNav) mobileNav();

			// Mark interactive elements with correct media query class. Used for proper event delegation
			setMqMarkers('mq-mobile', 'header nav');

			// Rebind resize event for desktop breakpoint
			$(window).off('resize', setMobileNav);
			$(window).on('resize', setDesktopNav);


			// Set mobile navigation main class. Close navigation by default.
			// FIXME: IE11 no support for multiple arguments
			body.classList.add(
				'navigation-for-mobile',
				'navigation-closed'
			);

			// Add second level navigation. It is unfolded by default on mobile
			// FIXME: Using default list of second levels include login navigation which should be closed.
			body.classList.add.apply(body.classList, secondMenuClasses);

			// 1st menu is closed by default on mobile
			body.classList.remove(
				'navigation-for-desktop',
				'first-menu-for-home'
			);

			// Reset 1st menu
			config.firstMenu = false;
			// FIXME: Set 2nd ,enu. There is an incorrect assumption in 'openSecondMenu' method, that there will be always some second level cached.
			config.secondMenu = secondMenuClasses.join(' ');
		}
	}

	return {};
});

 // Notification overlay for wrong download

 (function() {
     'use strict';
     var $ = avm.require('jquery'),
         detect = avm.require('avast.detect')(),
         detectedPlatform = detect.os.name.toLowerCase(),
         $document = $(document),
         currentPageName = getCurrentPageName(),
         supportedPlatforms = {
             "android": {
                 text: "Android",
                 style: "google-play.png"
             },
             "ios": {
                 text: "iOS",
                 style: "app-store.png"
             },
             "mac": {
                 text: "Mac",
                 style: "logo-mac"
             },
             "windows": {
                 text: "Windows",
                 style: "logo-win"
             }
         },
         defaultIconName = "google-play.png",
         config = window.avastGlobals && typeof window.avastGlobals.web !== 'undefined' && typeof window.avastGlobals.web['notification-overlay-for-wrong-download'] !== 'undefined' ? window.avastGlobals.web['notification-overlay-for-wrong-download'] : false,
         configCurrentPage = config[currentPageName],
         pageSupportedPlatform = typeof configCurrentPage !== 'undefined' ? configCurrentPage['supported-platform'].toLowerCase() : false;

     $document.ready(function() {
         if (checkIfApplyPopupLogicForCurrentPage()) {
             var $body = $('body'),
                 $popup = $('.js-notification-overlay-for-wrong-download'),
                 $popupButton = $popup.find('.js-popup-button'),
                 $platformPlaceHolderHeader = $popup.find('.detected-platform'),
                 $supportedPlatformPlaceHolder = $popup.find('.supported-platform'),
                 $downloadButton = $('[data-download-name=\"' + configCurrentPage['product-id'] + '\"]'),
                 downloadButtonData = {
                     'data-os': $downloadButton.attr('data-os') || pageSupportedPlatform,
                     'data-download-name': $downloadButton.attr('data-download-name') || configCurrentPage['product-id'],
                     'href': $downloadButton.attr('href') || null
                 },
                 $close = $popup.find('.js-close'),
                 bodyOverflow = $body.css('overflow');

             // Dynamicly update button for particular page
             $popupButton.attr('data-os', downloadButtonData['data-os']);
             $popupButton.attr('data-download-name', downloadButtonData['data-download-name']);
             $popupButton.attr('href', downloadButtonData.href);

             $close.on('click', function() {
                 $popup.removeClass('show-popup');
                 window.location.hash = '!';
                 $body.css('overflow', bodyOverflow);
             });

             $popup.on('click', function(event) {
                 if ($(event.target).is($popup)) {
                     $close.trigger('click');
                 }
             });

             $downloadButton.on('click', function(event) {
                 if (detectedPlatform !== pageSupportedPlatform) {
                     event.preventDefault();
                     event.stopPropagation();
                     $popup.addClass('show-popup');
                     $platformPlaceHolderHeader.text(supportedPlatforms[detectedPlatform].text);
                     $supportedPlatformPlaceHolder.text(supportedPlatforms[pageSupportedPlatform].text)
                     window.location.hash = 'oops';
                     $body.css('overflow', 'hidden');
                 }
             });

             updateInsteadLinks($popup);
             applyBrandingStyle($popup);

             // If platform is known but alternative download is missing
             if (detectOthers($popup)) {
                 $popup.addClass('detected-others');
             }
         }
     });

     // Checks whether current page name is listed in avastGlobals config. If not, skip popup logic
     // once localization  is done to all instances , language condition can be removed
     function checkIfApplyPopupLogicForCurrentPage() {
         if (config && window.avastGlobals.web.language === 'en') { // @todo : remove right side condition when localizations imported
             // Check config if page is there
             for (var page in config) {
                 if (page === currentPageName) {
                     buttonSelector();
                     return true;
                 }
             }
         }

         return false;
     }

     // In case we are changing installers based on different locations
     function buttonSelector() {
         if ($.isArray(configCurrentPage['product-id'])) {
             $.each(configCurrentPage['product-id'], function(i, val) {
                 if ($('[data-download-name=\"' + val + '\"]').length > 0)
                     configCurrentPage['product-id'] = val;
             });
         }
     }


     //if android/ios device , display store button instead of icons
     function applyBrandingStyle($popup) {
         var $popupButton = $popup.find('.js-popup-button'),
             $platformIcon = typeof $popupButton.find('img') !== 'undefined' ? $popupButton.find('img') : false;

         if ($platformIcon.length > 0) {
             if (pageSupportedPlatform === "ios" || pageSupportedPlatform === "android") {
                 $popupButton.removeClass('white');
                 $popupButton.find('span').remove();
                 var supportedPlatformIcon = $platformIcon.attr('src');
                 $platformIcon.attr('src', supportedPlatformIcon.replace(defaultIconName, supportedPlatforms[pageSupportedPlatform].style));
                 return;
             }
         }
         $popupButton.addClass(supportedPlatforms[pageSupportedPlatform].style);
         $platformIcon.remove();
     }


     function getCurrentPageName() {
         var pathnameSplitted = window.location.pathname.split('/');
         return pathnameSplitted[pathnameSplitted.length - 1];
     }


     /*
         poupulate corresponding properties with data from avastGlobals
         show .detected-{Detected OS}
     */
     function updateInsteadLinks($popup) {
         var alternativeLinks = configCurrentPage['alternative-links'],
             alternativeTracking = configCurrentPage['alternative-tracking'],
             $targetLinks = $popup.find('.detected-' + detectedPlatform).find('.js-instead-link');
         $popup.find('.detected-' + detectedPlatform).addClass('show');

         if (typeof alternativeLinks !== 'undefined') {
             $targetLinks.attr('href', alternativeLinks[detectedPlatform]);
         }

         if (typeof alternativeTracking !== 'undefined') {
             $targetLinks.attr('data-download-name', alternativeTracking[detectedPlatform]);
         }

         $targetLinks.attr('data-os', detectedPlatform);
     }

     // This function returns true if platform is known (Windows, Mac etc.), but there is no altertnative download
     function detectOthers($popup) {
         var _alternativeLinks = typeof configCurrentPage['alternative-links'] !== 'undefined' ? configCurrentPage['alternative-links'] : null;

         if (!$popup.hasClass('detected-unknown') && (_alternativeLinks === null || typeof _alternativeLinks[detectedPlatform] === 'undefined')) {
             return true;
         }

         return false;
     }
 })();
 // /Notification overlay for wrong download

/**
 * Unsupported browser message
 * @version 1.0.0
 * @author Fedor Kušš
 * @requires jquery
 * @requires avast.detect
 */

avm.define('avast.web.notSupportedBrowser', function() {
	'use strict';
	var $ = avm.require('jquery'),
		detectedBrowser = avm.require('avast.detect')().browser.name.toLowerCase(),
		detectedVersion = avm.require('avast.detect')().browser.version.toLowerCase(),
		notSupportedBrowser = detectedBrowser + detectedVersion.split('.')[0],
		$body = $('body');

	if (notSupportedBrowser === 'internetexplorer8' || notSupportedBrowser === 'internetexplorer9') {
		$body.addClass('notSupportedBrowser');
	}

})();

/**
 * Avast Platform Switcher
 * @version 1.2.1
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.platformSwitcher
 * @requires jquery
 * @requires avast.detect
 * @requires avast.web.router
 */
avm.define('avast.web.platformSwitcher', (function() {
	'use strict';
	var $ = avm.require('jquery'),
		detect = avm.require('avast.detect'),
		router = avm.require('avast.web.router'),
		android = 'android',
		ios = 'ios',
		mac = 'mac',
		pc = 'pc',
		platforms = [android, ios, mac, pc],
		disableHash = false,
		$body = $('body'),
		$jsPlatformSwitcher = $('.js-platform-switcher'),
		$popupButtons = $('.overlay-box .js-platform-switcher'),
		$overlayBoxClose = $('.overlay-box .close');
	return {
		init: function(param) {
			var self = this;

			if (param && 'disableHash' in param) {
				if (param.disableHash){
					disableHash = true;
					if (typeof window.avastGlobals !== "undefined" && typeof window.avastGlobals.web !== 'undefined') {
						window.avastGlobals.web.disableHash = true;
					}
				}
			} else if (typeof window.avastGlobals !== "undefined" && typeof window.avastGlobals.web !== 'undefined' && typeof window.avastGlobals.web.disableHash === true) {
				disableHash = true;
			}

			self.detectPlatform();
			self.switcher();
			self.closeOverlayBox();
			self.showButtons();
			if (!disableHash) {
				router.set({
					'pc': function() {
						self.addBodyClass(pc);
					},
					'mac': function() {
						self.addBodyClass(mac);
					},
					'android': function() {
						self.addBodyClass(android);
					},
					'ios': function() {
						self.addBodyClass(ios);
					}
				});
			}
		},
		// change root class and add hash to URL according to detected device
		detectPlatform: function() {
			var hash = window.location.hash,
				platform = hash.substring(1),
				rootPlatform;
			// add root class to body according to detected platform or detected hash from URL
			if (detect().os.isAndroid) {
				rootPlatform = android;
			} else if (detect().os.isIOS) {
				rootPlatform = ios;
			} else if (detect().os.isMac) {
				rootPlatform = mac;
			} else {
				rootPlatform = pc;
			}

			if (platforms.indexOf(platform) < 0) {
				platform = rootPlatform;
			}

			this.addRootClass(rootPlatform);
			if (disableHash) {
				this.addBodyClass(rootPlatform)
			} else {
				window.location.hash = platform;
			}
		},
		// add class according to used device
		addRootClass: function(platform) {
			$body.addClass('js-root-' + platform);
		},
		// remove platform classes
		resetPlatformClass: function() {
			$body.removeClass('js-pc js-android js-ios js-mac');
		},
		// remove platform classes and add class to body
		addBodyClass: function(platform) {
			this.resetPlatformClass();
			$body.addClass('js-' + platform);
		},
		// remove platform classes and add platform class according to clicked element
		switcher: function() {
			$jsPlatformSwitcher.on('click', function() {
				var self = $(this),
					selectPlatform;
				if (self.hasClass('js-android')) {
					selectPlatform = android;
				} else if (self.hasClass('js-ios')) {
					selectPlatform = ios;
				} else if (self.hasClass('js-mac')) {
					selectPlatform = mac;
				} else {
					selectPlatform = pc;
				}
				window.location.hash = selectPlatform;
			});
		},
		// close overlay-box when platform clicked
		closeOverlayBox: function() {
			$popupButtons.on('click', function(event) {
				event.preventDefault();
				$overlayBoxClose.trigger('click');
			});
		},
		// add class to body to show buttons, they are hidden by default to prevent showing all buttons at once on DOM load
		showButtons: function() {
			$body.addClass('js-show-buttons');
		}
	};
})());

var cookieStorage = avm.require('avast.storage.cookieStorage'),
    getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    },
    getExpirationTime = function (hours) {
        var now = new Date();
        now.setTime(now.getTime() + hours * 3600 * 1000);
        return now.toUTCString();
    };

if (getUrlParameter('gclsrc') && getUrlParameter('gclid')) {
    var domainName = window.location.hostname.substring(3);
    cookieStorage.setItem('gclid-avast', getUrlParameter('gclid'), getExpirationTime(24), '/', domainName, false);
}
/**
 * Shared cookie - Avast locale
 * @version 1.1.0
 * @author Michal Langhoffer <langhoffer@avast.com>
 * @requires avast.storage.cookieStorage
 */
avm.define('avast.web.sharedCookieAvastLocale', (function() {
	'use strict';
	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		cookieName = 'apex__avastLocale',
		locale = '';

	cookieStorage.removeItem(cookieName);

	if (typeof window.avastGlobals !== 'undefined' && typeof window.avastGlobals.web !== 'undefined' && typeof window.avastGlobals.web.locale !== 'undefined' && window.avastGlobals.web.locale.length > 0) {
		locale = window.avastGlobals.web.locale;
		cookieStorage.setItem(cookieName, locale, undefined, '/', '.avast.com');
	}

	return false;
})());

/**
 * Sticky nav for tabs. Sticky slide in to viewport when scrolled.
 * @version 0.7.0
 * @author Ales Gabriel <gabriel@avast.com>, Michal Langhoffer <langhoffer@avast.com>
 * @module avast.web.tabsAnchor
 * @requires module:jquery
 * @copyright Avast Software s.r.o &copy;2014-2015
 */

avm.define('avast.web.tabsAnchor', (function() {

	var $ = avm.require('jquery'),
		$window = $(window),
		waypoints = avm.require('avast.web.waypoints'),
		lastScrollTop = 0,
		direction;

	var tabsAnchor = {
		defaults: {
			behavior: 'slideIn'
		},
		init: function(nId, options){
			var opts = this.options = $.extend(true, this.defaults, options);

			if(nId && $(nId).length > 0) {
				this.stick(nId);
				this.highlight(nId);
				this.handleClick(nId);
				this.visible(nId);
			}
		},
		visible: function(nId) {
			var $bar = $(nId),
				windowScrollTop = $window.scrollTop(),
				$wrapper = $(nId).parent(),
				wrapperOffsetTop = $wrapper.offset().top;

			if (windowScrollTop > wrapperOffsetTop) {
				$bar.addClass('sticky');
			} else {
				$bar.removeClass('sticky');
			}
		},
		stick: function(nId){
			if(typeof waypoints === 'function'){

				var clone = $('<div id="tabs-anchor-clone">'),
					$this = $(nId),
					firstItemId = $(nId + ' ul:first li:first-child').find('a').attr('href'),
					lastItemId = $(nId + ' ul:first li:last-child').find('a').attr('href'),
					h = this.options.height ? this.options.height : $this.outerHeight(),
					p = $this.css('marginTop'),
					sTop = $window.scrollTop(),
					root = this;

				if(firstItemId && firstItemId.indexOf('#') !== 0){
					firstItemId = '-';
				}

				if(lastItemId && lastItemId.indexOf('#') !== 0){
					lastItemId = '-';
				}

				// Find correct anchored element
				if($(firstItemId).length === 0){
					$(nId + ' ul:first li').each(function(){
						var $this = $(this);
						var anchorId = $this.find('a').attr('href');
						if(anchorId){
							if(anchorId.indexOf('#') !== 0){
								return true;
							}
						}
						if($(anchorId).length > 0){
							firstItemId = anchorId;
							return false; // stop loop with first success
						}
					});
				}

				// TODO: Cure situation when item is in nav without approp section on page. Sticky bar is not hide when moved to top.
				// first tab reached
                $window.on('resize scroll', function() {
                    var st = $(this).scrollTop();
                    if (st > lastScrollTop){
                        direction = 'down';
                    } else {
                        direction = 'up';
                    }
					lastScrollTop = st;
					
					if ($this.parent().hasClass('partscreen')) {
						root.visible(nId);
					} else if ($(firstItemId).length > 0 && waypoints($(firstItemId), null, null, true)) {
                        $this.addClass('sticky');
                        if(root.options.behavior === 'static' && $('#tabs-anchor-clone').length < 1) {
                            clone.height(h);
                            $this.before(clone);
                        }
                    } else {
                        $this.removeClass('sticky');
                        if(root.options.behavior === 'static') {
                            clone.remove();
                        }
                    }

                    // last tab reached
                    if ($(lastItemId).length > 0 && waypoints($(lastItemId), null, null, true)) {
						$this.addClass('sticky');
						if(root.options.behavior === 'static' && $('#tabs-anchor-clone').length < 1) {
							clone.height(h);
							$this.before(clone);
						}
					}
					
					if ($(lastItemId).length > 0 && $(lastItemId).offset().top + $(lastItemId).outerHeight() - $(nId).outerHeight() < $window.scrollTop()) {
						$this.removeClass('sticky');
						if(root.options.behavior === 'static') {
							clone.remove();
						}
					}
                });
			}
		},
		highlight: function(nId) {
			var lastSection;

			$(nId + ' ul:first').find('a').each(function(){
				var href = $(this).attr('href');
				var id = href.replace(/#/,'');

				$('#content-holder').children().each(function(index){
					if(id == $(this).attr('id')){
						$(this).addClass('tabs-anchor-section');
						// last child
						lastSection = $(this);
					}
				});
			});

			if(lastSection){
				lastSection.addClass('last-anchor-section');
			}

			$('.tabs-anchor-section').each(function() {
				var $self = $(this);
				if ($self.length > 0) {
					$window.on('resize scroll', function() {
						if (waypoints($self, null, null, true)) {
							var id;
	
							$(nId + ' ul:first').find('a').removeClass('active');
								id = $self.attr('id');
								$('[href="#'+ id +'"]').addClass('active');
	
	
							var el = $self;
							var timeout = setTimeout(function(){
								$(el).trigger({
									type: 'passed.waypoint',
									direction: direction,
									offset: 500
								});
								clearTimeout(timeout);
							}, 100);
						}
					});
				}
            });
		},
		handleClick: function(nId) {
			var $item = $(nId + ' ul li a');

			$item.on('click', function(event) {
				function updateActiveItem() {
					$item.removeClass('active');
					$(event.target).addClass('active');
					clearTimeout($.data(this, 'scrollTimer'));

					// Wait until page stops scrolling
					$.data(this, 'scrollTimer', setTimeout(function() {
						$(event.target).addClass('active');
						$window.off('scroll', updateActiveItem)
					}, 50));
				}

				$window.on('scroll', updateActiveItem);
			});
		}
	};

	return tabsAnchor;

})());

/**
 * Avast brcmpgid parameter
 * @version 1.0.0
 * @author Jaroslav Slaby <jaroslav.slaby@avast.com>
 * @module avast.web.brcmpgid
 * @requires avast.url.unserialize
 * @requires avast.web.linkDecorator
 * @copyright Avast Software s.r.o &copy;2021
 */

(function() {
	'use strict';

		var unserialize = avm.require('avast.url.unserialize'),
			linkDecorator = avm.require('avast.web.linkDecorator'),
			qs = unserialize(),
			productId = 'ASB',
			re = /^[a-z0-9]+$/i;

			if (qs && qs.brcmpgid && re.test(qs.brcmpgid) || qs && qs.pc && re.test(qs.pc)) {

				var ASBLinks = document.querySelectorAll('[data-download-name*="' + productId + '"]')

				for (var i = 0; i < ASBLinks.length; i++) {
					if ('URLSearchParams' in window) {
						var el = ASBLinks[i],
							downloadURL,
							downloadQueryString;

						if(!/ANDROID|IOS/.test(el.getAttribute('data-download-name'))) {
							if (el.href) {
								downloadURL = new URL(el.href);
								downloadQueryString = new URLSearchParams(downloadURL.search);

								downloadQueryString.set('product', el.getAttribute('data-download-name') + '-CID');

								if (qs.brcmpgid !== undefined) {
									downloadQueryString.set('tag', qs.brcmpgid);
								}

								if (qs.pc !== undefined) {
								downloadQueryString.set('pc', qs.pc);
								}

								downloadURL.search = downloadQueryString.toString();
								el.href = downloadURL.toString();
							}
						}
					} else {
						// IE fallback
						var el = ASBLinks[i],
						href,
						downloadQueryString;

						if(!/ANDROID|IOS/.test(el.getAttribute('data-download-name'))) {
							downloadQueryString = el.search;
							href = el.href.replace(downloadQueryString, '');

							el.href = href + downloadQueryString.replace('=' + el.getAttribute('data-download-name') + '&', '=' + el.getAttribute('data-download-name') + '-CID&');

							linkDecorator(el, 'tag', 'tag=null', qs.brcmpgid);
						}
					}
				}
			}

	return;

})();

/**
 * Decorate Buy Links with Campaign Marker if Present in URL
 * @version 1.0.0
 * @author Fedor Kušš <fedor.kuss@avast.com>
 * @module avast.web.mobileTracking
 * @requires jquery
 * @requires avast.storage.cookieStorage
 * @requires avast.url.unserialize
 */

avm.define('avast.web.campaignMarkerDecorator', $(document).ready(function() {
	'use strict';
	var cookieStorage = avm.require('avast.storage.cookieStorage'),
		$cartLink = $('.bi-cart-link'),
		unserializedUrl = avm.require('avast.url.unserialize')(window.location.href),
		cmpgMarker = unserializedUrl.campaignMarker,
		CMPGNMARKER = 'campaignMarker',

		getExpirationTime = function(minutes) {
			var now = new Date();
			now.setTime(now.getTime() + minutes * 60 * 1000);
			return now.toUTCString();
		};

	if (cmpgMarker && cmpgMarker.length > 0) {
		cookieStorage.setItem('campaignMarker', cmpgMarker, getExpirationTime(30), '/', location.hostname, false);
	}

	$cartLink.on('click', function() {
		if (cookieStorage.getItem('campaignMarker') && cookieStorage.getItem('campaignMarker').length > 0)	{

			var link = $(this).attr('href'),
				isCampaignMarker = link.indexOf(CMPGNMARKER),
				updatedLink = [],
				campainMarker = cookieStorage.getItem(CMPGNMARKER);

			// if cartlink parameters in query param (avast)
			// else cartlink parameters in link (avast,avg)
			if (link.indexOf('?') >= 0) {
				var linkVariables1 = link.split('&');

				linkVariables1.forEach(function(item) {
					var params = item.split('=');
					if (params[0] === 'CampaignMarker') {
						updatedLink.push(params[0] + '=' + params[1] + '-' + campainMarker);
					} else {
						updatedLink.push(item);
					}
				});
				$(this).attr('href', updatedLink.join('&'));
			} else {
				var linkVariables = link.split('/');

				linkVariables.forEach(function(item) {
					var params = item.split('.');

					if (params[0] === CMPGNMARKER) {
						updatedLink.push(params[0] + '.' + params[1] + '-' + campainMarker);
					} else {
						updatedLink.push(item);
					}
					if (params[0] === 'Currency' && isCampaignMarker === -1) {
						updatedLink.push(CMPGNMARKER + '.' + campainMarker);
					}
				});

				$(this).attr('href', updatedLink.join('/'));
			}
		}
	});
}));

/**
 * Avast CampaignMarker (decorate cart links and update data attributes)
 * @version 0.0.5
 * @author Ales Gabriel, Jaroslav Slaby <gabriel@avast.com> <jaroslav.slaby@avast.com>
 * @module avast.web.campaignMarkerCookie
 * @requires module:avast.storage.cookieStorage
 * @copyright Avast Software s.r.o &copy;2020
 */

avm.define('avast.web.campaignMarkerCookie', function() {

	var cookieStorage = avm.require('avast.storage.cookieStorage');

	var cm = {
		cookie: '__trSrc',
		SMBCookeValue: cookieStorage.getItem('__smbChannelSrc'),
		els: document.querySelectorAll('a[data-campaign-marker]'),
		getCampaignMarkerCookie: function(cookie) {
			var cookieName = cookie,
				cookieValue = cookieStorage.getItem(cookieName),
				result;

			if (cookieValue && encodeURIComponent) {
				cookieValue = encodeURIComponent(cookieValue);
				result = cookieValue;
			}
			return result;
		},
		replaceCookieString: function(str, cookie) {
			var re = /~trSrcCookieValue/;

			return str.replace(re, '~' + cookie);
		},
		decorateCartLink: function(data) {
			var href,
				el = data.currentTarget,
				cookieValue = cm.getCampaignMarkerCookie(cm.cookie) || '';

			if (el) {
				el.href = cm.replaceCookieString(el.href, cookieValue);

				href = el.href;
			}

			return href;
		},
		updateDataAttr: function(data) {
			var campaignMarker,
				el = data.currentTarget,
				cookieValue = cm.getCampaignMarkerCookie(cm.cookie) || '';

			if (el.dataset && el.dataset.campaignMarker) {
				el.dataset.campaignMarker = cm.replaceCookieString(el.dataset.campaignMarker, cookieValue);

				campaignMarker = el.dataset.campaignMarker;
			}

			return campaignMarker;
		},

		/**
		 *
		 * @param {HTMLElement|NodeList} els List of elements
		 */

		setCampaignMarkerCookie: function(els) {
			var nodeList = els || cm.els,
				nodes = els instanceof HTMLElement ? [els] : Array.prototype.slice.call(nodeList),
				cookieValue = cm.getCampaignMarkerCookie(cm.cookie),
				SMBCookeValue = cm.SMBCookeValue,
				SMBRegExp = /smbChannelSrcCookieValue-/,
				links = [];

			if (cookieValue) {
				nodes.forEach(function(el) {
					var result = {
						el: el
					};

					result.link = cm.decorateCartLink({
						currentTarget: el
					});
					result.dataAttr = cm.updateDataAttr({
						currentTarget: el
					});

					links.push(result);
				});
			} else {
				// Register mousedown event.
				// FIXME: Move to scanner on DOM ready.
				nodes.forEach(function(el) {
					el.addEventListener('mousedown', cm.decorateCartLink);
					el.addEventListener('mousedown', cm.updateDataAttr);
					el.addEventListener('focus', cm.decorateCartLink);
					el.addEventListener('focus', cm.updateDataAttr);

					links.push({
						el: el,
						evt: 'mousedown',
						callback: cm.decorateCartLink
					});
					links.push({
						el: el,
						evt: 'mousedown',
						callback: cm.updateDataAttr
					});
				});
			}

			nodes.forEach(function(el) {
				if (el.href.match(SMBRegExp) || el.getAttribute('data-campaign-marker').match(SMBRegExp)) {
					if (cm.SMBCookeValue !== null) {
						var cookieValue = cm.SMBCookeValue.slice(-1) === '-' ? cm.SMBCookeValue : cm.SMBCookeValue + '-';
						el.href = el.href.replace(SMBRegExp, cookieValue);
						el.dataset.campaignMarker = el.dataset.campaignMarker.replace(SMBRegExp, cookieValue);
					} else {
						el.href = el.href.replace(SMBRegExp, '');
						el.dataset.campaignMarker = el.dataset.campaignMarker.replace(SMBRegExp, '');
					}
				}
			})

			return links;
		}
	};

	return cm;

});

/**
 * Display Chrome Offer in non-chrome browsers
 * @version 1.2.0
 * @author Ales Gabriel <gabriel@avast.com>
 * @module avast.web.chromeBanner
 * @requires jquery
 * @requires avast.detect
 * @requires avast.url.unserialize
 * @requires avast.web.tracker
 */
avm.define('avast.web.chromeBanner', (function () {
	'use strict';

	var $ = avm.require('jquery');
	var detect = avm.require('avast.detect')();
	var urlParams = avm.require('avast.url.unserialize')();
	var tracker = avm.require('avast.web.tracker');

	// Chrome banner
	var chromeBanner = {
		init: function(){
			var hasBanner = $('#offer-chrome').length;
			var isChrome = detect.browser.isChrome;
			var product = (typeof urlParams.product === 'string') ? urlParams.product : '';
			var isMsBuild = (product.indexOf('-ONLINE-MS') > -1) ? true : false;
			var isAsb = /ASB/.test(product);

			if(hasBanner){
				if(!isChrome && !isMsBuild && !isAsb){
					this.show();
					$('#offer-chrome').on('click', '.button', this.trackClick);
				}
			}
		},
		show: function(e){
			var url = document.location.href,
				pExt = url.match(/[?&]p_ext=([^&]*)/),
				pExtVal = pExt ? pExt[1].toLowerCase() : '';

			if (url.indexOf('?') > -1) {
				url = url.substr(0, url.indexOf("?"));
			}

			if(pExtVal.indexOf('chrome') == -1 && !/secure-browser/.test(url)){
				$('#offer-chrome').show();
				tracker.track('chromeOffer.view', e);
			}
		},
		trackClick: function(e){
			tracker.track('chromeOffer.click', e);
		}
	};

	return chromeBanner;

})());

/**
 * Cookie Consent - perform cookie consent
 * @version 1.0.0
 * @author Michal Langhoffer
 * @requires jquery
 * @requires avast.storage.cookieStorage
 */

avm.define('avast.web.cookieConsent', function() {
    'use strict';
    var $ = avm.require('jquery'),
        cookieStorage = avm.require('avast.storage.cookieStorage'),
        cookieName = 'consentAccepted',
        domainName = window.location.hostname.substring(3);

    $(document).ready(function() {
        var CookieBar = {},
            $footer = $('#footer'),
            footerInitialPadding = $footer.css('padding-bottom'),
            footerInitialMargin = $footer.css('margin-bottom'),
            mediaQuery = function () {
                var screen = (window.getComputedStyle) ? window.getComputedStyle(document.body, ':after').getPropertyValue('content') : '';
                return screen;
            },
            mobileScreen = (mediaQuery() === '\'mobile\'' || mediaQuery() === "\"mobile\"" || mediaQuery() === "mobile") ? true : false;

        CookieBar.cookieDom = $('.js-cookie-bar');
        CookieBar.cookieCloseDom = $('.js-cookie-bar .js-close');

        /**
         * @description Close the cookie-bar by removing it from the DOM, and saving this preference to the local storage
         */
        CookieBar.close = function() {
            var today = new Date(),
                expire = new Date();

            expire.setTime(today.getTime() + 3600000 * 24 * 14); // 14 days

            try {
                cookieStorage.setItem(cookieName, 'true', expire.toGMTString(), '/', domainName);
                dataLayer.push({
                    'event': 'cookie-bar-consent-granted'
                });
            } catch (error) {
                console.log('Unable to store preference in local storage, cookiebar will show upon next visit', error);
			}

            CookieBar.cookieDom.remove();

            if (mobileScreen) {
                $footer.css('padding-bottom', footerInitialPadding);
            } else {
                $footer.css('margin-bottom', footerInitialMargin);
            }
        };

        /**
         * @description Initialise the CookieBar component, by binding all the event handlers
         */
        CookieBar.initialise = function() {
            // Cookiebar will be visible either when the key doesn't exist (getItem returns null) or returns another value than "true"
            if (cookieStorage.getItem(cookieName) !== 'true') {
                CookieBar.cookieDom.addClass('visible');

                CookieBar.cookieDom.on('transitionend webkitTransitionEnd oTransitionEnd', function(event) {
                    if (mobileScreen) {
                        $footer.css('padding-bottom', CookieBar.cookieDom.height() + 'px');
                    } else {
                        $footer.css('margin-bottom', CookieBar.cookieDom.height() + 'px');
                    }
                });
                dataLayer.push({
                    'event': 'cookie-bar-displayed'
                });
                CookieBar.cookieCloseDom.click(CookieBar.close);
            } else {
                CookieBar.cookieDom.remove();
                if (mobileScreen) {
                    $footer.css('padding-bottom', footerInitialPadding);
                }
            }
        };

        CookieBar.initialise();
    });
});

/**
 * Avast Config Module
 * @version 0.13.0
 * @module avast.web.config
 * @author Ales Gabriel <gabriel@avast.com>
 * @requires module:avast.detect
 * @requires module:jquery
 * @requires module:avast.web.appendPbld
 * @requires module:avast.web.aswparam
 * @requires module:avast.web.cj
 * @requires module:avast.web.couponCode
 * @requires module:avast.hadd
 * @requires module:avast.web.navigation
 * @requires module:avast.web.tabs
 * @requires module:avast.web.tabsAnchor
 * @requires module:avast.scroll.smoothScroll
 * @requires module:avast.web.setLanguage
 * @requires module:avast.web.chromeBanner
 * @requires module:avast.web.tracker
 * @requires module:avast.web.cookieConsent
 * @requires module:avast.web.footer
 * @requires module:avast.web.campaignMarkerCookie
 * @requires module:avast.web.linkScanner
 * @copyright AVAST Software s.r.o.
 */

avm.define('avast.web.config', (function() {
	'use strict';

	var $ = avm.require('jquery');

	// Prevent log errors on browsers without console.
	if (!window.console) {
		window.console = {
			log: function() {}
		};
	}

	// Config environment
	var config = {
		options: {},

		/**
		 * Basic setup - init modules + legacy
		 */
		init: function() {
			var opts = window.avastGlobals ? window.avastGlobals.web || {} : {};
			var legacy = this.legacySettings(opts);
			var boot = this.boot;

			/**
			 * Global namespace options
			 */
			this.options = opts;

			/*
			 * Support former avast config settings in global namespace
			 */
			this.exportLegacy(legacy, window);

			/**
			 * Global modules
			 *
			 * @description Boot global modules. First param of boot function is a module name.
			 * Second is init function. Module is passed os parameter.
			 */

			// Init legacy free modules
			avm.require('avast.web.tracker');

			/*
			 *
			 * !!! COMMENTS WITH avm.require STATEMENT BEFORE EACH boot ARE MANDATORY !!!
			 * CORRECT ORDER DURING CONCAT IS NOT GUARANTED WITHOUT THAT.
			 *
			 */

			$(document).ready(function() {
				var disabledModules = avastGlobals.disabledModules || [];

				// avm.require('avast.web.appendPbld') -  Add p_bld param to cart links
				boot('avast.web.appendPbld', function(module) {
					if (!avast.disableAppendPbld) {
						module.init();
					}
				});

				// avm.require('avast.web.aswparam') - Pack and add ASWPARAM to cart links
				boot('avast.web.aswparam', function(module) {
					if (!avast.disableAswparam) {
						module.init();
					}
				});

				// avm.require('avast.web.cj') - Set CJ cookie
				boot('avast.web.cj', function(module) {
					if (!avast.disableCj) {
						module.init();
					}
				});

				// avm.require('avast.web.couponCode') - Add couponcode param to cart links
				boot('avast.web.couponCode', function(module) {
					if (!avast.disableShowCouponCode) {
						module.init();
					}
				});

				// avm.require('avast.hadd') - Add couponcode param to cart links
				boot('avast.hadd', function(module) {
					if (!avast.disableHadd) {
						var hadd = module();
						hadd.init();
					}
				});

				// avm.require('avast.web.navigation') - Navigation
				boot('avast.web.navigation', function(module) {
					var navSel = '.js-navigation-bootstrap';
					if (document.querySelector(navSel)) {
						module(navSel);
					}
				});

				// avm.require('avast.web.tabs') - Tabs in v8 style. Not initialized if tabs in sticky bar.
				boot('avast.web.tabs', function(module) {
					if (!avast.disableTabs && $('#tabs-anchor').hasClass('tabs-nav')) {
						module.init('#content-holder', {
							tabs: '#tabs-anchor li'
						});
					}
				});

				// avm.require('avast.web.tabsAnchor') - Tabs in v8 style. Not initialized if tabs in sticky bar.
				boot('avast.web.tabsAnchor', function(module) {
					var detect = avm.require('avast.detect')();
					var ie6zh = detect.browser.isInternetExplorer &&  detect.browser.version === '6.0' && window.avastGlobals.web.locale === 'zh-cn' ? 1 : 0;

					if (!avast.disableTabsAnchor && !ie6zh) {
						// window.avast.tabsAnchor = window.avast.tabsAnchor || module;
						module.init('#tabs-anchor');
					}
				});

				// avm.require('avast.scroll.smoothScroll') - Animate scrolls
				boot('avast.scroll.smoothScroll', function(module) {
					if (!avast.disableSmoothScroll) {
						module();
					}
				});

				// avm.require('avast.web.chromeBanner') - Chrome banner visibility and tracking
				boot('avast.web.chromeBanner', function(module) {
					module.init();
				});

				// avm.require('avast.web.setLanguage') - Chrome banner visibility and tracking
				boot('avast.web.setLanguage', function(module) {
					if (!avast.disableSetLanguage) {
						module(opts.locale || '');
					}
				});

				// avm.require('avast.web.slider') - BxSlider wrapper
				boot('avast.web.slider', function(slider) {
					var detect = avm.require('avast.detect')();
					var ie6zh = detect.browser.isInternetExplorer && detect.browser.version === '6.0' && window.avastGlobals.web.locale === 'zh-cn' ? 1 : 0;

					if (avast.disableSlider) {
						return;
					}

					// Product slider
					if ($('#features .slider-slides').length > 0) {
						slider.init('v9', '#features .slider-slides', {
							pager: false
						});
					}

					// index slider (also used on business)
					if ($('#top .slider-slides').length > 0 && !ie6zh) {
						slider.init('v9hp', '#top .slider-slides', {
							pager: true,
							pagerSelector: '#top .control',
							buildPager: function() {
								return '<span class="bullet"></span>';
							}
						});

						// Rum log
						rum.track('error', {
							message: 'Slider #top called'
						});
					}

					// Extra sliders on /index + /online-backup + /grimefighter
					if ($('#results .slider-slides, #whybackup .slider-slides').length > 0) {
						var context = $('#results, #whybackup');
						var ppBx = $('#results .slider-slides, #whybackup .slider-slides').bxSlider({
							auto: false,
							pager: true,
							pagerSelector: '#results .control, #whybackup .control',
							infiniteLoop: true,
							moveSlides: 1,
							minSlides: 1,
							maxSlides: 1,
							slideWidth: 900,
							slideMargin: 0,
							controls: false,
							nextSelector: '',
							prevSelector: '',
							useCSS: false,
							onSliderLoad: function() {
								$('.bx-clone').css('visibility', 'visible');
								$('#results-slides').css('visibility', 'visible');
							},
							buildPager: function(slideIndex) {
								return '<span class="bullet"></span>';
							}
						});

						context.find('.prev').click(function(e) {
							ppBx.goToPrevSlide();
							e.preventDefault(); // FIXME
						});

						context.find('.next').click(function(e) {
							ppBx.goToNextSlide();
							e.preventDefault(); // FIXME
						});

						// Rum log
						rum.track('error', {
							message: 'Slider #results#whybackup called'
						});
					}

					// Sliders on /business
					if ($('#results-business .slider-slides').length > 0) {
						// Rum log
						rum.track('error', {
							message: 'Slider #results-business called'
						});
					}
				});

				// avm.require('avast.web.cookieConsent') - Cookie consent bar
				boot('avast.web.cookieConsent', function(module) {
					if (!avast.disableCookieConsent) {
						module();
					}
				});

				// avm.require('avast.web.footer') - Footer scripts (langugage selector)
				boot('avast.web.footer', function(module) {
					module();
				});

				// avm.require('avast.web.campaignMarkerCookie') - Cookie consent bar
				boot('avast.web.campaignMarkerCookie', function(module) {
					var cm = module();
					cm.setCampaignMarkerCookie();
				});

				// avm.require('avast.web.linkScanner') - Scan and update cart/download links
				boot('avast.web.linkScanner', function(module) {
					var scanner = module();

					if (avastGlobals.web.language === 'en') {
						scanner.init({
							tasks: ['downloadPopup'],
							selectors: ['[data-download-name^="FAV-"]:not([data-behavior="downloadPage"])']
						});
					}
				});

				/*
				 * jQuery plugins
				 */

				// Return to the top of the page button
				if (typeof $.fn.slideTop === 'function') {
					$('#content-holder').slideTop();
				}
				// Initialize tooltip plugin
				if (typeof $.fn.tooltip === 'function' &&
					navigator.userAgent.indexOf('aclwebview') === -1 &&
					Array.prototype.indexOf &&
					disabledModules.indexOf('tooltip') === -1 &&
					avastGlobals.web.contentGroup !== 'SMB') {
					$('#content-holder').tooltip();
				}

				// Set class for comparison table cell with tick
				if ($('#comparison').length > 0) {
					$('#comparison table tr.feature span.yes').closest('td').addClass('cell-tick');
				}
				if ($('#compare-table').length > 0) {
					$('#compare-table table tr.feature span.yes').closest('td').addClass('cell-tick');
				}
				if ($('#compare').length > 0) {
					$('#compare table tr.feature span.yes').closest('td').addClass('cell-tick');
				}

				// FIX height in IE
				var detect = avm.require('avast.detect')();

				if (detect.browser.isInternetExplorer) {
					var topHeight = $('#top.fullscreen .AVsizer .absolute-center').height();

					if (topHeight) {
						$('#top.fullscreen .AVsizer').css({
							minHeight: topHeight + 25 + 'px'
						});
					}
				}
			});
		},

		/**
		 * Invoke global modules
		 * @param  {string}   moduleName    Module name
		 * @param  {Function} fn            Init function
		 * @returns {*}                    Module instance. Object is prefered
		 */
		boot: function(moduleName, fn) {
			var config = this;
			var req = avm.require;
			var module = moduleName ? req(moduleName, false) : null;

			try {
				fn.call(config, module);
			} catch (e) {
				// console.log(moduleName + ': ' + e); // Send custom RUM event here?
				return false;
			} finally {
				return module;
			}
		},

		/**
		 * legacySettings Config settings in global namespace
		 * @param  {Object} opts Settings options
		 * @returns {Object}      Object equals former global namespace settings
		 */
		legacySettings: function(opts) {
			var detect = avm.require('avast.detect')();

			if (opts) {
				return {
					locale: opts.locale,
					RootPath: opts.RootPath,
					avast: {
						locale: opts.locale,
						numberDecimalSeparator: opts.numberDecimalSeparator,
						numberThousandSeparator: opts.numberThousandSeparator,
						responsive: opts.responsive,
						rootPath: opts.RootPath,
						options: {
							locale: opts.locale,
							rootPath: opts.RootPath
						},
						getOS: function() {
							return detect.os.name;
						},
						getWinVersion: function() {
							return detect.os.version;
						},
						tabsAnchor: (function() {
							return avm.require('avast.web.tabsAnchor');
						})(),
						slider: (function() {
							return avm.require('avast.web.slider');
						})(),
						hadd: (function() {
							return avm.require('avast.hadd')();
						})()
					}
				};
			}
		},

		/**
		 * Extend global namespace with avast variables
		 * @param  {Object} src    Object to be merged
		 * @param  {Object} target Object to be extended
		 * @returns {string}        Not merged variables
		 */
		exportLegacy: function(src, target) {
			var skipped;

			for (var key in src) {
				if (Object.prototype.toString.call(src[key]) !== '[object Object]' && src[key] !== null) {
					if (!(key in target)) {
						target[key] = src[key];
					} else {
						skipped = !skipped ? key : skipped + ', ' + key;
					}
				} else {
					target[key] = target[key] || {};
					this.exportLegacy(src[key], target[key]);
				}
			}

			// todo: log skipped
			// console.log('settings: %o', target);
			return target;
		},

		/**
		 * Get current config options
		 * @return {Object} Config options
		 */
		getConfig: function() {
			return this.options;
		}
	};

	// Run config
	config.init();

	return config;
})());
